import React, { memo, forwardRef, useEffect, useCallback, useRef } from 'react';
import Muted from '@lifesize/ux-assets/vectors/svgIcons/mic-off.svg';
import SVG from 'react-inlinesvg';
import Enabled from '@lifesize/ux-assets/vectors/svgIcons/mic.svg';
import { makeStyles, createMuiTheme, fade, createStyles } from '@material-ui/core/styles';
import Fab from '@material-ui/core/Fab';
import clsx from 'clsx';
import { makeStyles as makeStyles$1, Box, FormControl, InputLabel, TextField, withStyles, MenuItem, useTheme, Snackbar as Snackbar$1, SwipeableDrawer as SwipeableDrawer$1 } from '@material-ui/core';
import MaterialButton from '@material-ui/core/Button';
import Icon from '@lifesize/ux-assets/vectors/svgIcons/cancel.svg';
import Icon$1 from '@lifesize/ux-assets/vectors/svgIcons/chat.svg';
import MaterialSelect from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import EndCall from '@lifesize/ux-assets/vectors/svgIcons/end-call.svg';
import MaterialModal from '@material-ui/core/Modal';
import Icon$2 from '@lifesize/ux-assets/vectors/svgIcons/more.svg';
import peopleIcon from '@lifesize/ux-assets/vectors/svgIcons/people.svg';
import Pip from '@lifesize/ux-assets/vectors/svgIcons/pip.svg';
import PipOff from '@lifesize/ux-assets/vectors/svgIcons/pip-off.svg';
import Icon$3 from '@lifesize/ux-assets/vectors/svgIcons/share-screen.svg';
import handIcon from '@lifesize/ux-assets/vectors/svgIcons/hand.svg';
import StopRecording from '@lifesize/ux-assets/vectors/svgIcons/record-stop.svg';
import Record from '@lifesize/ux-assets/vectors/svgIcons/record.svg';
import Icon$4 from '@lifesize/ux-assets/vectors/svgIcons/again.svg';
import Icon$5 from '@lifesize/ux-assets/vectors/svgIcons/settings.svg';
import MaterialSwitch from '@material-ui/core/Switch';
import Vbb from '@lifesize/ux-assets/vectors/svgIcons/wallpaper.svg';
import SvgIcon from '@material-ui/core/SvgIcon';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var primaryColors = {
    charcoal: '#1f2933',
    lifesize: '#5650D7' // rgb(86,80,215)
};
var secondaryColors = {
    aubergine: '#4f49d6',
    darkTeal: '#007a85',
    grape: '#3a3691',
    lavender: '#ada8ff',
    lightSlateGray: '#616e7c',
    lightTeal: '#79f7f5',
    lilac: '#8882ff',
    neutralGray: '#9aa5b1',
    solitude: '#e3e7eb',
    stone: '#cbd2d9',
    stormcloud: '#3e4c59',
    teal: '#00b5b3',
    white: '#ffffff' // rgb(255, 255, 255)
};
var supportingColors = {
    brightGreen: '#00d991',
    chiliPepper: '#f15353',
    darkPepper: '#dd3030',
    goldenPoppy: '#fec600',
    magenta: '#c3216a',
    marigold: '#ff9228',
    mint: '#00c18b' // rgb(0, 193, 139)
};
var colors = __assign(__assign(__assign({ black: '#000000', nimbusCloud: '#f5f7fa' }, supportingColors), secondaryColors), primaryColors);

var micStyles = makeStyles(function (theme) { return ({
    micLevel: {
        background: "linear-gradient(" + theme.palette.primary.contrastText + " 50%, " + colors.brightGreen + " 50%)",
        backgroundPosition: function (config) { return "left 0px top " + (config.micLevel || 0) + "%"; },
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 200%',
        height: 40,
        opacity: function (config) { return (config.disabled ? 0.4 : 1); },
        width: 40,
        transition: 'background-position 0.2s',
        '-webkit-mask-image': "url(" + Enabled + ")",
        '-webkit-mask-mode': 'alpha',
        '-webkit-mask-position': 'center',
        '-webkit-mask-repeat': 'no-repeat',
        '-webkit-mask-size': '40px'
    }
}); });
var MicLevel = function (props) {
    var audioClasses = micStyles(props);
    return React.createElement("div", { className: audioClasses.micLevel });
};

// default       |0px     600px    960px    1280px   1920px
// our value     |0px     375px    768px    1024px   1366px
// key           |xs      sm       md       lg       xl
// screen width  |--------|--------|--------|--------|-------->
// range         |   xs   |   sm   |   md   |   lg   |   xl
var theme = createMuiTheme({
    breakpoints: {
        values: { xs: 0, sm: 375, md: 768, lg: 1024, xl: 1366 }
    },
    palette: {
        primary: {
            main: colors.lifesize,
            light: colors.lilac,
            dark: colors.grape,
            contrastText: colors.white
        },
        secondary: {
            light: colors.stone,
            main: colors.charcoal,
            dark: colors.black
        },
        error: {
            main: colors.chiliPepper,
            dark: colors.darkPepper
        },
        background: {
            default: colors.nimbusCloud
        }
    },
    typography: {
        htmlFontSize: 10,
        fontSize: 14,
        fontWeightLight: 300,
        fontWeightRegular: 400,
        fontWeightMedium: 500,
        fontWeightBold: 700,
        h1: {
            fontWeight: 500,
            fontSize: '3.2rem',
            lineHeight: 1.25
        },
        h2: {
            fontWeight: 500,
            fontSize: '2.4rem',
            lineHeight: 1.33
        },
        h3: {
            fontWeight: 500,
            fontSize: '2.0rem',
            lineHeight: 1.4
        },
        h4: {
            fontWeight: 'normal',
            fontSize: '1.8rem',
            lineHeight: 1
        },
        h5: {
            fontWeight: 'normal',
            fontSize: '1.6rem',
            lineHeight: 1
        },
        h6: {
            fontWeight: 'normal',
            fontSize: '1.4rem',
            lineHeight: 1
        },
        subtitle1: {
            fontSize: '1.6rem',
            color: colors.lightSlateGray
        },
        button: {
            fontWeight: 500,
            fontSize: '1.6rem',
            lineHeight: 1.5,
            letterSpacing: '0.5px',
            textTransform: 'none'
        }
    },
    overrides: {
        MuiTooltip: {
            tooltip: {
                fontSize: '1.2rem'
            }
        }
    }
});

var defaultStyle = {
    backgroundColor: fade(colors.black, 0.5),
    backgroundColorHover: fade(colors.black, 0.25),
    border: 'none',
    color: theme.palette.primary.contrastText,
    height: 60,
    width: 60
};
var useStyles = makeStyles(function () { return createStyles({
    toggleButton: {
        backgroundColor: function (currentStyle) { return currentStyle.backgroundColor; },
        border: function (currentStyle) { return currentStyle.border; },
        color: function (currentStyle) { return currentStyle.color; },
        height: function (currentStyle) { return currentStyle.height; },
        margin: 0,
        width: function (currentStyle) { return currentStyle.width; },
        '&:hover': {
            backgroundColor: function (currentStyle) { return currentStyle.backgroundColorHover; },
        },
        '& svg': {
            height: 40
        },
        '&.Mui-disabled': {
            border: '2px solid',
            color: colors.neutralGray
        }
    },
    disabledOverride: {
        "&:disabled": {
            color: colors.neutralGray
        }
    }
}); });

var getStyleOverride = function (selected, styleOverride) {
    return __assign({ backgroundColor: selected ? colors.white : fade(colors.black, 0.5), backgroundColorHover: selected ? fade(colors.white, 0.75) : fade(colors.black, 0.25), border: selected ? 'none' : "2px solid " + colors.white, color: selected ? theme.palette.error.main : theme.palette.primary.contrastText }, (styleOverride && styleOverride));
};
var BaseInCallButton = memo(forwardRef(function (props, ref) {
    var className = props.className, disabled = props.disabled, label = props.label, onClick = props.onClick, selected = props.selected, styleOverride = props.styleOverride, other = __rest(props, ["className", "disabled", "label", "onClick", "selected", "styleOverride"]);
    var classes = useStyles(__assign(__assign({}, defaultStyle), getStyleOverride(selected, styleOverride)));
    // selected is 'muted' for this component
    var clickHandler = function (e) {
        e.preventDefault();
        onClick(e);
    };
    return (React.createElement(Fab, __assign({ "aria-label": label, className: clsx(classes.toggleButton, className), disabled: disabled, onClick: clickHandler, ref: ref }, other), props.children ? props.children : ''));
}));

var AudioButton = memo(forwardRef(function (props, ref) {
    var micLevel = props.micLevel, otherProps = __rest(props, ["micLevel"]);
    return (React.createElement(BaseInCallButton, __assign({ ref: ref }, otherProps), props.selected ? React.createElement(SVG, { src: Muted }) : React.createElement(MicLevel, { micLevel: micLevel, disabled: !!props.disabled })));
}));

var useStyles$1 = makeStyles$1(function (theme) { return ({
    container: {
        alignItems: 'center',
        backgroundColor: colors.mint,
        borderRadius: 10,
        boxSizing: 'border-box',
        color: theme.palette.primary.contrastText,
        display: 'flex',
        fontSize: '1.4rem',
        height: 20,
        justifyContent: 'center',
        minWidth: 20,
        padding: '2px 3px'
    }
}); });
var Badge = function (props) {
    var classes = useStyles$1();
    return (React.createElement("div", { "data-testid": "badge", className: clsx(classes.container, props.classes) }, props.label));
};

// These styles are specifically for our standard rectangular button
var useStyles$2 = makeStyles$1(function () {
    var _a;
    return ({
        button: (_a = {
                borderRadius: 0,
                boxShadow: 'none',
                minHeight: 56,
                padding: '16px 32px 13px'
            },
            _a[theme.breakpoints.down('sm')] = {
                maxWidth: 328,
                minWidth: 156
            },
            _a[theme.breakpoints.up('sm')] = {
                maxWidth: 343,
                minWidth: 164
            },
            _a[theme.breakpoints.up('md')] = {
                maxWidth: 352,
                minWidth: 168
            },
            _a['&:hover'] = {
                boxShadow: 'none'
            },
            _a['&:active'] = {
                backgroundColor: colors.grape
            },
            _a)
    });
});
/**
 * Button.
 * Displays a clickable button.
 */
var Button = forwardRef(function (props, ref) {
    var classes = useStyles$2(theme);
    var className = props.className, otherProps = __rest(props, ["className"]);
    return React.createElement(MaterialButton, __assign({ ref: ref, className: clsx(classes.button, className) }, otherProps));
});

// These styles are specifically for our standard rectangular button
var useStyles$3 = makeStyles$1(function (theme) { return ({
    buttonBar: {
        alignItems: 'center',
        bottom: 12,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        left: 0,
        position: 'absolute',
        right: 0,
        'z-index': 999
    },
    callControls: {
        alignItems: 'center',
        display: 'flex',
        maxHeight: 60,
        '&>.lsCallControl': {
            margin: "0 " + theme.spacing(1) + "px"
        }
    }
}); });
var classKeys = {
    // can potentially be used together with any className prop to target the call control container
    buttonContainer: 'lsCallControls'
};
/**
 * Button.
 * Displays a clickable button.
 */
var ButtonBar = function (props) {
    var callDuration = props.callDuration, className = props.className, children = props.children, otherProps = __rest(props, ["callDuration", "className", "children"]); // otherProps allows us to pass data-testid, etc.
    var classes = useStyles$3();
    return (React.createElement(Box, __assign({ className: clsx(classes.buttonBar, className) }, otherProps),
        callDuration,
        React.createElement(Box, { className: clsx(classes.callControls, classKeys.buttonContainer) }, children)));
};

var CancelButton = memo(forwardRef(function (props, ref) {
    return (React.createElement(BaseInCallButton, __assign({ ref: ref }, props),
        React.createElement(SVG, { src: Icon })));
}));

var getStyleOverride$1 = function () {
    return {
        backgroundColor: fade(colors.black, 0.5),
        backgroundColorHover: fade(colors.white, 0.25),
        border: "2px solid " + colors.white,
        color: theme.palette.primary.contrastText
    };
};
var ChatButton = memo(forwardRef(function (props, ref) {
    return (React.createElement(BaseInCallButton, __assign({ ref: ref, styleOverride: getStyleOverride$1() }, props),
        React.createElement(SVG, { src: Icon$1 })));
}));

var getStyleOverride$2 = function () {
    return {
        backgroundColor: 'transparent',
        backgroundColorHover: fade(colors.black, 0.15),
        border: 'none',
        color: colors.neutralGray,
        height: 40,
        width: 40
    };
};
var CloseButton = memo(forwardRef(function (props, ref) { return (React.createElement(BaseInCallButton, __assign({ ref: ref, styleOverride: getStyleOverride$2() }, props),
    React.createElement(SVG, { src: Icon }))); }));

var useStyles$4 = makeStyles(function (theme) { return ({
    select: {
        backgroundColor: theme.palette.primary.contrastText,
        textAlign: 'left',
        borderRadius: '0px',
        '& .MuiSelect-root': {
            border: "solid 1.5px " + theme.palette.secondary.light,
            borderRadius: 0
        },
        '& [aria-expanded="true"]': {
            border: "solid 1.5px " + theme.palette.primary.main
        },
        '& fieldset': {
            borderRadius: '0px',
            borderWidth: '1.5px',
            '&:hover': {
                borderColor: "" + theme.palette.primary.main
            }
        }
    },
    inputLabel: {
        color: colors.charcoal,
        fontSize: '14px',
        marginBottom: theme.spacing(1),
        position: 'relative',
        transform: 'none'
    },
    formControl: {
        margin: 0,
        maxWidth: '500px'
    }
}); });
/**
 * Dropdown Component.
 * Below Props are required to Work this Dropdown component properly, otherwise it will have side effect such
 * as not able to update the state, label not displaying correctly, etc.
 * 1 . inputProps: it contains name and Id prop for the input component which will be generated by Material select
 *     name props and the state variable name should be same as it will help reduce redundant code.
 *     Please refer Dropdown.stories.tsx for more details.
 * @param props
 * @constructor
 */
var Dropdown = forwardRef(function (props, ref) {
    var classes = useStyles$4(theme);
    var label = props.label, children = props.children, errorString = props.errorString, otherProps = __rest(props, ["label", "children", "errorString"]);
    var paperProps = {
        elevation: 2,
        square: true
    };
    var menuProps = {
        PaperProps: paperProps,
        getContentAnchorEl: null,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'center'
        },
        transformOrigin: {
            vertical: 'top',
            horizontal: 'center'
        }
    };
    return (React.createElement(FormControl, { ref: ref, className: classes.formControl, variant: 'outlined', fullWidth: true, error: !!errorString },
        label && (React.createElement(InputLabel, { variant: 'outlined', className: classes.inputLabel, shrink: false }, label)),
        React.createElement(MaterialSelect, __assign({ className: classes.select, variant: 'outlined', fullWidth: true, MenuProps: menuProps }, otherProps), children),
        errorString && React.createElement(FormHelperText, null, errorString)));
});

var getStyleOverride$3 = function () {
    return {
        backgroundColor: theme.palette.error.dark,
        backgroundColorHover: theme.palette.error.main,
        color: theme.palette.primary.contrastText,
        border: 'none',
    };
};
var EndCallButton = memo(forwardRef(function (props, ref) {
    return (React.createElement(BaseInCallButton, __assign({ ref: ref, styleOverride: getStyleOverride$3() }, props),
        React.createElement(SVG, { src: EndCall })));
}));

var useStyles$5 = makeStyles$1(function (theme) { return ({
    root: {
        '& fieldset': {
            borderRadius: 0,
            borderWidth: '1.5px',
            borderColor: colors.stone
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: colors.lifesize
        },
        '& + .MuiFormHelperText-root': {
            margin: theme.spacing(1) + "px 0"
        }
    },
    input: {
        fontSize: '1.4rem',
        fontFamily: ['Graphik', 'Roboto', '"Helvetica Neue"', 'Arial', 'sans-serif'].join(',')
    }
}); });
/**
 * Button.
 * Displays a clickable button.
 */
var LifesizeInput = forwardRef(function (props, ref) {
    var classes = useStyles$5(theme);
    var className = props.className, otherProps = __rest(props, ["className"]);
    otherProps.variant = (otherProps === null || otherProps === void 0 ? void 0 : otherProps.variant) ? otherProps.variant : 'outlined';
    return React.createElement(TextField, __assign({ ref: ref, InputProps: { classes: classes }, className: className }, otherProps));
});

var styles = function () { return ({
    root: {
        '&:hover': {
            backgroundColor: 'rgb(173,168,255, 0.25)',
        },
        '&.Mui-selected': {
            backgroundColor: colors.lavender + " !important",
        },
        '&.Mui-selected:hover': {
            backgroundColor: colors.lavender + " !important",
        },
    }
}); };
var LifesizeMenuItem = withStyles(styles())(MenuItem);

var useStyles$6 = makeStyles(function (theme) {
    var _a;
    return ({
        select: (_a = {
                background: 'none',
                textAlign: 'left',
                color: colors.lifesize,
                fontSize: '1.4rem',
                maxWidth: 180,
                minWidth: 80,
                padding: '10px 0',
                textTransform: 'none',
                '&:before': {
                    border: 'none !important'
                },
                '&:after': {
                    border: 'none'
                }
            },
            _a[theme.breakpoints.down('sm')] = {
                minWidth: 120
            },
            _a['& .MuiSelect-select'] = {
                marginRight: theme.spacing(1),
                '&:focus': {
                    background: 'none'
                }
            },
            _a['& .MuiSelect-icon'] = {
                color: 'inherit'
            },
            _a['& .MuiMenuItem-root'] = {
                fontSize: '1em'
            },
            _a),
        formControl: {
            margin: 0,
            maxWidth: '500px'
        },
        menuItem: {
            fontSize: '1.4rem'
        }
    });
});
/**
 * Dropdown Component.
 * Below Props are required to Work this Dropdown component properly, otherwise it will have side effect such
 * as not able to update the state, label not displaying correctly, etc.
 * 1 . inputProps: it contains name and Id prop for the input component which will be generated by Material select
 *     name props and the state variable name should be same as it will help reduce redundant code.
 *     Please refer Dropdown.stories.tsx for more details.
 * @param props
 * @constructor
 */
var LanguageSwitcher = function (props) {
    var classes = useStyles$6(theme);
    var handleSelect = props.handleSelect, languageId = props.languageId, languageOptions = props.languageOptions, className = props.className, classNameMenuItem = props.classNameMenuItem, otherProps = __rest(props, ["handleSelect", "languageId", "languageOptions", "className", "classNameMenuItem"]);
    var handleSelectLanguage = function (selectedLanguage) {
        var selectedOption = languageOptions.find(function (opt) { return opt.id === selectedLanguage.target.value; });
        if (selectedOption)
            handleSelect(selectedOption);
    };
    var paperProps = {
        elevation: 2,
        square: true
    };
    var menuProps = {
        PaperProps: paperProps,
        getContentAnchorEl: null,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'center'
        },
        transformOrigin: {
            vertical: 'top',
            horizontal: 'center'
        }
    };
    return (React.createElement(FormControl, { className: classes.formControl },
        React.createElement(MaterialSelect, __assign({ className: clsx(classes.select, className), fullWidth: true, MenuProps: menuProps, onChange: handleSelectLanguage, value: languageId }, otherProps), languageOptions.map(function (opt) { return (React.createElement(LifesizeMenuItem, { key: opt.id, value: opt.id, className: clsx(classes.menuItem, classNameMenuItem) }, opt.displayName)); }))));
};

var useStyles$7 = makeStyles(function (theme) {
    return createStyles({
        container: {
            color: colors.charcoal,
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            textAlign: 'center',
            position: 'absolute',
            width: 500,
            backgroundColor: theme.palette.background.paper,
            borderRadius: '5px',
            boxShadow: theme.shadows[5],
            padding: theme.spacing(2, 4, 3),
            '&:focus': {
                outline: 'none'
            },
            '& header': {
                margin: '0 20px 8px'
            }
        },
        headerBar: {
            fontSize: '2.5rem',
            maxWidth: 'none'
        },
        content: {
            display: 'flex',
            flexDirection: 'column'
        },
        closeButton: {
            boxShadow: 'none',
            position: 'absolute',
            right: theme.spacing(2),
            top: theme.spacing(2)
        }
    });
});
var Modal = function (props) {
    var classes = useStyles$7({});
    var open = props.open, closeLabel = props.closeLabel, title = props.title, children = props.children, onClose = props.onClose;
    var handleClose = function () {
        props.onClose();
    };
    return (React.createElement(MaterialModal, { "aria-labelledby": "dialog-title", "aria-describedby": "dialog-description", open: open, onClose: handleClose },
        React.createElement("div", { className: classes.container },
            React.createElement(CloseButton, { "data-testid": "dialogClose", onClick: onClose, label: closeLabel, className: classes.closeButton }),
            !!title && (React.createElement("header", null,
                React.createElement("div", { className: classes.headerBar }, title))),
            React.createElement("div", { className: classes.content }, !!children && children))));
};

var getStyleOverride$4 = function () {
    return {
        backgroundColor: colors.white,
        backgroundColorHover: fade(colors.white, 0.25),
        border: "2px solid " + colors.white,
        color: theme.palette.primary.contrastText
    };
};
var MoreButton = memo(forwardRef(function (props, ref) {
    return (React.createElement(BaseInCallButton, __assign({ ref: ref, styleOverride: getStyleOverride$4() }, props),
        React.createElement(SVG, { src: Icon$2 })));
}));

var getStyleOverride$5 = function () {
    return {
        backgroundColor: fade(colors.black, 0.5),
        backgroundColorHover: fade(colors.white, 0.25),
        border: "2px solid " + colors.white,
        color: theme.palette.primary.contrastText
    };
};
var ParticipantsButton = memo(forwardRef(function (props, ref) {
    return (React.createElement(BaseInCallButton, __assign({ ref: ref, styleOverride: getStyleOverride$5() }, props),
        React.createElement(SVG, { src: peopleIcon })));
}));

var PipButton = memo(forwardRef(function (props, ref) {
    return (React.createElement(BaseInCallButton, __assign({ ref: ref }, props), props.selected ? React.createElement(SVG, { src: PipOff }) : React.createElement(SVG, { src: Pip })));
}));

var getStyleOverride$6 = function (selected) {
    return {
        backgroundColor: selected ? colors.mint : fade(colors.black, 0.5),
        backgroundColorHover: selected ? fade(colors.brightGreen, 0.75) : fade(colors.black, 0.25),
        color: theme.palette.primary.contrastText
    };
};
var PresentButton = memo(forwardRef(function (props, ref) {
    return (React.createElement(BaseInCallButton, __assign({ ref: ref, styleOverride: getStyleOverride$6(props.selected) }, props),
        React.createElement(SVG, { src: Icon$3 })));
}));

var getStyleOverride$7 = function (selected) {
    return {
        backgroundColor: selected ? colors.mint : fade(colors.black, 0.5),
        backgroundColorHover: selected ? fade(colors.brightGreen, 0.75) : fade(colors.black, 0.25),
        color: theme.palette.primary.contrastText
    };
};
var RaiseHandButton = memo(forwardRef(function (props, ref) {
    return (React.createElement(BaseInCallButton, __assign({ ref: ref, styleOverride: getStyleOverride$7(props.selected) }, props),
        React.createElement(SVG, { src: handIcon })));
}));

var getStyleOverride$8 = function (selected) {
    return {
        backgroundColor: colors.white,
        backgroundColorHover: selected ? fade(colors.white, 0.75) : fade(colors.white, 0.25),
        color: theme.palette.error.main,
    };
};
var RecordingButton = memo(forwardRef(function (props, ref) { return (React.createElement(BaseInCallButton, __assign({ ref: ref, styleOverride: getStyleOverride$8(props.selected) }, props), props.selected ? React.createElement(SVG, { src: StopRecording }) : React.createElement(SVG, { src: Record }))); }));

var getStyleOverride$9 = function () {
    return {
        backgroundColor: colors.lifesize,
        backgroundColorHover: fade(colors.lifesize, 0.75),
        border: 'none'
    };
};
var RetryButton = memo(forwardRef(function (props, ref) { return (React.createElement(BaseInCallButton, __assign({ ref: ref, styleOverride: getStyleOverride$9() }, props),
    React.createElement(SVG, { src: Icon$4 }))); }));

var getStyleOverride$a = function (selected) {
    return {
        backgroundColor: selected ? colors.white : 'transparent',
        backgroundColorHover: selected ? fade(colors.white, 0.75) : fade(colors.white, 0.25),
        border: 'none',
        color: selected ? colors.lifesize : theme.palette.primary.contrastText
    };
};
var SettingsButton = memo(forwardRef(function (props, ref) {
    return (React.createElement(BaseInCallButton, __assign({ ref: ref, styleOverride: getStyleOverride$a(props.selected) }, props),
        React.createElement(SVG, { src: Icon$5 })));
}));

var useStyles$8 = makeStyles$1(function (theme) { return ({
    snackbar: {
        bottom: theme.spacing(11)
    }
}); });
/**
 * Snackbar component
 * @param message
 * @param autoHideDuration - if provided then it will override default auto hide duration(6000 ms).
 * @param disableAutoHide  - if provided do not auto close snackbar.
 * @constructor
 */
var Snackbar = function (_a) {
    var message = _a.message, autoHideDuration = _a.autoHideDuration, disableAutoHide = _a.disableAutoHide, onClose = _a.onClose;
    var _b = React.useState(!!message), open = _b[0], setOpen = _b[1];
    var theme = useTheme();
    var classes = useStyles$8(theme);
    useEffect(function () {
        setOpen(!!message);
    }, [message]);
    var handleClose = function () {
        if (disableAutoHide) {
            return;
        }
        if (onClose) {
            onClose();
        }
        setOpen(false);
    };
    if (!message)
        return null;
    return (React.createElement(Snackbar$1, { className: classes.snackbar, anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'center'
        }, autoHideDuration: autoHideDuration || 6000, open: open, onClose: handleClose, ContentProps: {
            'aria-describedby': 'snackbar-msg-id',
            role: 'alert'
        }, message: React.createElement("span", { id: 'snackbar-msg-id' }, message) }));
};

var useStyles$9 = makeStyles$1(function () { return ({
    drawerPaper: {
        backgroundColor: colors.nimbusCloud
    },
    countLabel: {
        '& span': {
            color: colors.stormcloud,
            fontSize: 18
        }
    },
    closeButton: {
        boxShadow: 'none',
        position: 'absolute',
        right: theme.spacing(2),
        top: theme.spacing(2)
    }
}); });
var SwipeableDrawer = function (props) {
    var classes = useStyles$9();
    var closeButtonProps = props.closeButtonProps, children = props.children, isIos = props.isIos, other = __rest(props, ["closeButtonProps", "children", "isIos"]);
    var dataTestId = closeButtonProps.dataTestId, label = closeButtonProps.label, closeDrawer = closeButtonProps.closeDrawer;
    return (React.createElement(React.Fragment, null,
        React.createElement(SwipeableDrawer$1, __assign({ classes: {
                paper: classes.drawerPaper
            }, disableBackdropTransition: !isIos, disableDiscovery: isIos, disableScrollLock: true }, other),
            children,
            React.createElement(CloseButton, { "data-testid": dataTestId, onClick: closeDrawer, label: label, className: classes.closeButton }))));
};

var useStyles$a = makeStyles$1(function (theme) { return ({
    switch: {
        width: '58px',
        height: '38px',
        padding: 0,
        '& .MuiSwitch-switchBase': {
            padding: 0,
            '&:hover': {
                backgroundColor: 'transparent'
            },
            '&.Mui-checked': {
                transform: 'translateX(21px)',
                color: theme.palette.common.white,
                '&+.MuiSwitch-track': {
                    backgroundColor: colors.white,
                    border: "1px solid " + colors.brightGreen
                },
                '& .MuiSwitch-thumb': {
                    backgroundColor: colors.brightGreen
                }
            }
        },
        '& .MuiSwitch-thumb': {
            width: 27,
            height: 27,
            backgroundColor: colors.stone,
            margin: '3px 2px',
            boxShadow: 'none'
        },
        '& .MuiSwitch-track': {
            width: '51px',
            height: '31px',
            borderRadius: 38 / 2,
            border: "1px solid " + colors.stone,
            backgroundColor: colors.white,
            opacity: 1,
            transition: theme.transitions.create(['background-color', 'border'])
        }
    }
}); });
var Switch = forwardRef(function (props, ref) {
    var classes = useStyles$a(theme);
    return React.createElement(MaterialSwitch, __assign({ ref: ref, className: classes.switch, size: 'medium', disableRipple: true }, props));
});

var useStyles$b = makeStyles$1(function () { return ({
    container: {
        alignItems: 'center',
        border: "2px solid " + colors.stone,
        borderRadius: '2em',
        boxSizing: 'border-box',
        display: 'inline-flex',
        height: '4em',
        padding: '0 2px',
        position: 'relative',
        transform: 'none',
        width: 'auto',
        '&:before': {
            // selected indicator
            backgroundColor: colors.stone,
            borderRadius: '50%',
            display: 'block',
            content: "''",
            height: 'calc(4em - 8px)',
            left: function (opts) { return "calc(" + opts.valueIndex + " * (4em - 8px))"; },
            margin: '0 2px',
            position: 'absolute',
            top: '50%',
            transform: 'translate(0, -50%)',
            transition: 'left 0.2s ease-in-out',
            width: 'calc(4em - 8px)'
        }
    },
    icon: {
        color: colors.stone,
        cursor: 'pointer',
        flex: '0 0 auto',
        height: 'calc(4em - 8px)',
        transition: 'color 0.2s ease-in-out',
        width: 'auto',
        zIndex: 1,
        '&.selected': {
            color: colors.black
        }
    }
}); });
var MultiSwitch = function (props) {
    var className = props.className, disabled = props.disabled, onSelect = props.onSelect, options = props.options, value = props.value;
    var valueIndex = options.findIndex(function (opt) { return opt.value === value; });
    var classes = useStyles$b({ valueIndex: valueIndex });
    var handleClick = useCallback(function (optValue) {
        if (!disabled) {
            onSelect(optValue);
        }
    }, [disabled]);
    return (React.createElement("div", { className: clsx(classes.container, className) }, options.map(function (opt, index) {
        return (React.createElement(SVG, { className: clsx(classes.icon, opt.value === value && 'selected'), key: "option-" + index, onClick: function () { return handleClick(opt.value); }, src: opt.icon }));
    })));
};

var VbbButton = memo(forwardRef(function (props, ref) {
    // NOTE: we can add a toggle to use a "VbbOff" later.
    return (React.createElement(BaseInCallButton, __assign({ ref: ref }, props), props.selected ? React.createElement(SVG, { src: Vbb }) : React.createElement(SVG, { src: Vbb })));
}));

const icons = {
  again: {
    path: 'M12,4.615V2.963c0-0.415-0.498-0.618-0.785-0.323L8.631,5.215c-0.185,0.185-0.185,0.471,0,0.655l2.575,2.575 C11.502,8.732,12,8.529,12,8.114V6.461c3.055,0,5.539,2.483,5.539,5.539c0,0.729-0.138,1.44-0.406,2.077 c-0.138,0.332-0.037,0.711,0.212,0.96c0.471,0.471,1.265,0.305,1.514-0.314c0.342-0.84,0.526-1.763,0.526-2.723 C19.385,7.92,16.08,4.615,12,4.615z M12,17.539c-3.055,0-5.539-2.483-5.539-5.539c0-0.729,0.138-1.44,0.406-2.077 c0.138-0.332,0.037-0.711-0.212-0.96C6.185,8.492,5.391,8.658,5.141,9.277C4.8,10.117,4.615,11.04,4.615,12 c0,4.08,3.305,7.385,7.385,7.385v1.652c0,0.415,0.498,0.618,0.785,0.323l2.575-2.575c0.185-0.185,0.185-0.471,0-0.655l-2.575-2.575 C12.498,15.268,12,15.471,12,15.886V17.539z',
    viewBox: '0 0 24 24'
  },
  alertOutline: {
    path: 'M11,15h2v2h-2V15z M11,7h2v6h-2V7z M11.99,2C6.47,2,2,6.48,2,12s4.47,10,9.99,10C17.52,22,22,17.52,22,12S17.52,2,11.99,2z M12,20c-4.42,0-8-3.58-8-8s3.58-8,8-8s8,3.58,8,8S16.42,20,12,20z',
    viewBox: '0 0 24 24'
  },
  alert: {
    path: 'M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M13,17h-2v-2h2V17z M13,13h-2V7h2V13z',
    viewBox: '0 0 24 24'
  },
  calendar: {
    path: 'M18.4,6.4C19.282,6.4,20,7.119,20,8v10.4c0,0.882-0.717,1.6-1.6,1.6H5.6C4.717,20,4,19.282,4,18.4V8 c0-0.881,0.717-1.6,1.6-1.6h1.6V8H8V4h1.6v2.4h5.6V8H16V4h1.6v2.4H18.4z M18.398,18.4L18.4,9.6H5.6v8.8 C5.6,18.4,18.397,18.4,18.398,18.4z M11.2,11.2h3.2v3.2h-3.2V11.2z M7.2,11.2h3.2v3.2H7.2V11.2z',
    viewBox: '0 0 24 24'
  },
  callMissed: {
    path: 'M5.39,10.625l8.644,8.25L22,9.331l-2.712-1.941l-5.593,6.633L7.762,8.36h6.102V5.125H2v11.324h3.39L5.39,10.625z',
    viewBox: '0 0 24 24'
  },
  callOutgoing: {
    path: 'M4,17.669l2.33,2.33L16.704,9.628v7.559H20V4.001H6.815v3.296h7.557L4,17.669z',
    viewBox: '0 0 24 24'
  },
  cancel: {
    path: 'M4.889,4L12,11.111L19.111,4L20,4.889L12.889,12L20,19.111L19.111,20L12,12.889L4.889,20L4,19.111L11.111,12L4,4.889 L4.889,4z',
    viewBox: '0 0 24 24'
  },
  caretDown: {
    path: 'M12,17l8-10H4L12,17z',
    viewBox: '0 0 24 24'
  },
  caretLeft: {
    path: 'M17,20V4L7,12L17,20z',
    viewBox: '0 0 24 24'
  },
  caretRight: {
    path: 'M17,12L7,4v16L17,12z',
    viewBox: '0 0 24 24'
  },
  caretUp: {
    path: 'M4,17h16L12,7L4,17z',
    viewBox: '0 0 24 24'
  },
  chat: {
    path: 'M19.201,9.997c0.44,0,0.799,0.357,0.799,0.792v5.543c0,0.435-0.359,0.792-0.799,0.792h-0.8V19.5l-2.399-2.375H12 c-0.44,0-0.799-0.357-0.799-0.792v-5.543c0-0.435,0.359-0.792,0.799-0.792C12,9.997,19.201,9.997,19.201,9.997z M17.063,5.275v3.102 h-6.916c-0.422,0-0.768,0.349-0.768,0.776v5.428H7.842l-2.305,2.327v-2.327H4.769C4.347,14.582,4,14.233,4,13.807V5.275 C4,4.849,4.347,4.5,4.769,4.5h11.525C16.717,4.5,17.063,4.849,17.063,5.275z',
    viewBox: '0 0 24 24'
  },
  check: {
    path: 'M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z',
    viewBox: '0 0 24 24'
  },
  chevronBack: {
    path: 'M9.914,12l7.39-7.391L15.695,3l-9,9l9,9l1.61-1.609L9.914,12z',
    viewBox: '0 0 24 24'
  },
  chevronDown: {
    path: 'M4.609,6.695L3,8.305l9,9l9-9l-1.609-1.609L12,14.086L4.609,6.695z',
    viewBox: '0 0 24 24'
  },
  chevronNext: {
    path: 'M14.086,12l-7.39,7.391L8.305,21l9-9l-9-9l-1.61,1.609L14.086,12z',
    viewBox: '0 0 24 24'
  },
  chevronUp: {
    path: 'M12,9.914l7.391,7.39L21,15.695l-9-9l-9,9l1.609,1.61L12,9.914z',
    viewBox: '0 0 24 24'
  },
  clipboard: {
    path: 'M8.695,16.262c0-1.863,1.197-3.036,3.099-3.036s3.099,1.173,3.099,3.036H8.695L8.695,16.262z M11.793,12.214 c-1.141,0-2.066-0.906-2.066-2.024s0.925-2.024,2.066-2.024s2.066,0.906,2.066,2.024S12.934,12.214,11.793,12.214z M13.653,4.119 h1.653v2.428H8.695V4.119h1.653C10.347,3.226,11.088,2.5,12,2.5S13.653,3.225,13.653,4.119z M17.785,4.928 c0.912,0,1.653,0.725,1.653,1.619v11.333c0,0.893-0.741,1.619-1.653,1.619H6.215c-0.912,0-1.653-0.726-1.653-1.619V6.548 c0-0.894,0.741-1.619,1.653-1.619h0.827v1.619H6.215v11.333h11.57L17.784,6.548h-0.827V4.928L17.785,4.928L17.785,4.928z',
    viewBox: '0 0 24 24'
  },
  collaborationTools: {
    path: 'M10.762,10.897l-0.415,0.359l0.124,0.533c0.023,0.097-0.083,0.174-0.168,0.122l-0.469-0.284l-0.469,0.283 c-0.086,0.052-0.191-0.025-0.168-0.122l0.124-0.533l-0.415-0.359c-0.076-0.066-0.035-0.19,0.064-0.198l0.546-0.046l0.214-0.503 c0.038-0.092,0.17-0.092,0.208,0l0.214,0.504l0.546,0.046C10.797,10.707,10.838,10.831,10.762,10.897z M5.273,13.411l-0.546-0.046 l-0.214-0.504c-0.038-0.092-0.17-0.092-0.208,0l-0.214,0.503L3.546,13.41c-0.099,0.008-0.14,0.132-0.064,0.198l0.415,0.359 l-0.124,0.533c-0.023,0.097,0.082,0.174,0.168,0.122L4.41,14.34l0.469,0.284c0.086,0.052,0.191-0.025,0.168-0.122l-0.124-0.533 l0.415-0.359C5.413,13.544,5.373,13.419,5.273,13.411z M12.269,9.158l-1.472-1.05l-0.432,0.605l1.472,1.05L12.269,9.158z M20.086,8.413l-1.4,1.145l0.471,0.576l1.4-1.145L20.086,8.413z M11.954,15.515c0,0.962-0.781,1.742-1.742,1.742H9.594 c-0.289,0-0.523,0.233-0.523,0.523c0,0.132,0.052,0.254,0.132,0.345c0.084,0.094,0.136,0.216,0.136,0.352 C9.34,18.767,9.107,19,8.817,19c-1.732,0-3.136-1.404-3.136-3.136c0-1.732,1.404-3.136,3.136-3.136 C10.549,12.728,11.954,13.975,11.954,15.515z M7.424,15.341c0-0.289-0.233-0.523-0.523-0.523c-0.289,0-0.523,0.233-0.523,0.523 c0,0.289,0.233,0.523,0.523,0.523C7.19,15.864,7.424,15.63,7.424,15.341z M8.469,13.947c0-0.289-0.233-0.523-0.523-0.523 c-0.289,0-0.523,0.233-0.523,0.523s0.233,0.523,0.523,0.523C8.235,14.47,8.469,14.237,8.469,13.947z M10.211,13.947 c0-0.289-0.233-0.523-0.523-0.523c-0.289,0-0.523,0.233-0.523,0.523s0.233,0.523,0.523,0.523 C9.978,14.47,10.211,14.237,10.211,13.947z M11.257,15.341c0-0.289-0.233-0.523-0.523-0.523c-0.289,0-0.523,0.233-0.523,0.523 c0,0.289,0.233,0.523,0.523,0.523C11.023,15.864,11.257,15.63,11.257,15.341z M4.88,12.491l1.2-0.083 c0.051-0.004,0.101-0.027,0.134-0.069l4.012-4.603L8.644,6.359l-4.008,4.602c-0.037,0.042-0.053,0.091-0.049,0.146l0.083,1.2 C4.677,12.418,4.77,12.498,4.88,12.491z M11.291,6.513c0.143-0.165,0.126-0.413-0.038-0.556l-0.987-0.86 c-0.079-0.069-0.182-0.103-0.286-0.096s-0.202,0.056-0.27,0.135L9.037,5.908l1.582,1.378L11.291,6.513z M18.989,12.304 c0,1.21-0.605,2.273-1.526,2.919v1.149c0,0.28-0.229,0.509-0.509,0.509h-3.051c-0.28,0-0.509-0.229-0.509-0.509v-1.149 c-0.921-0.646-1.526-1.709-1.526-2.919c0-1.963,1.597-3.56,3.56-3.56S18.989,10.341,18.989,12.304z M17.971,12.304 c0-1.404-1.139-2.543-2.543-2.543c-1.404,0-2.543,1.139-2.543,2.543c0,0.829,0.407,1.607,1.093,2.085l0.432,0.305v1.17h2.034v-1.17 l0.432-0.305C17.565,13.911,17.971,13.133,17.971,12.304z M13.903,18.407c0,0.28,0.229,0.509,0.509,0.509h2.034 c0.28,0,0.509-0.229,0.509-0.509v-0.509h-3.051V18.407z M15.777,6.258h-0.744v1.808h0.744V6.258z M13.857,8.214L13.004,6.62 l-0.656,0.351l0.854,1.594L13.857,8.214z M18.692,7.124L18.075,6.71l-1.007,1.502l0.618,0.414L18.692,7.124z',
    viewBox: '0 0 24 24'
  },
  compose: {
    path: 'M10.575,10.692l2.382,2.262L9.98,13.519C9.98,13.519,10.575,10.692,10.575,10.692z M19.507,6.73l-5.359,5.092L11.766,9.56 l5.359-5.091c0.658-0.625,1.724-0.625,2.382,0C20.164,5.093,20.164,6.106,19.507,6.73L19.507,6.73z M17.475,20.001H5.684 C4.755,20.001,4,19.283,4,18.4V7.199c0-0.882,0.756-1.6,1.684-1.6h5.895v1.6H5.684V18.4h11.79V11.2h1.684V18.4 C19.159,19.283,18.403,20.001,17.475,20.001z',
    viewBox: '0 0 24 24'
  },
  contentPopout: {
    path: 'M18.933,5.6C19.52,5.6,20,6.08,20,6.667v9.6c0,0.587-0.48,1.067-1.067,1.067h-4.8 c0,0.587-0.48,1.067-1.067,1.067h-8C4.48,18.4,4,17.92,4,17.333V12c0-0.587,0.48-1.067,1.067-1.067H5.6V6.667 C5.6,6.08,6.08,5.6,6.667,5.6H18.933z M17.867,6.667H7.733c-0.587,0-1.013,0.427-1.067,1.013v0.053v3.2h6.4 c0.587,0,1.067,0.48,1.067,1.067v4.267h3.733c0.587,0,1.013-0.427,1.067-1.013V15.2V7.733C18.933,7.147,18.453,6.667,17.867,6.667z M17.867,7.733v3.2L16.853,9.92L16,10.773l-1.12-1.12L15.733,8.8l-1.067-1.067H17.867z',
    viewBox: '0 0 24 24'
  },
  crown: {
    path: 'M16.8,18.206H7.2v-1h9.6V18.206z M20,10.194c0,0.662-0.537,1.2-1.2,1.2c-0.065,0-0.13-0.01-0.193-0.02l-1.807,4.82H7.2 l-1.807-4.82c-0.063,0.01-0.128,0.02-0.193,0.02c-0.663,0-1.2-0.538-1.2-1.2s0.54-1.2,1.203-1.2c0.662,0,1.2,0.538,1.2,1.2 c0,0.177-0.043,0.345-0.11,0.495L8.1,11.774c0.383,0.23,0.883,0.1,1.105-0.29l2.037-3.565c-0.268-0.22-0.443-0.55-0.443-0.925 c0-0.662,0.538-1.2,1.2-1.2s1.2,0.538,1.2,1.2c0,0.375-0.175,0.705-0.443,0.925l2.037,3.565c0.223,0.39,0.72,0.52,1.105,0.29 l1.81-1.085c-0.07-0.152-0.11-0.318-0.11-0.495c0-0.662,0.538-1.2,1.2-1.2C19.463,8.994,20,9.532,20,10.194z M17.257,12.127 l-0.845,0.506c-0.279,0.167-0.599,0.255-0.923,0.255c-0.645,0-1.243-0.348-1.563-0.908L12,8.609l-1.927,3.371 c-0.319,0.56-0.919,0.908-1.564,0.908c-0.325,0-0.645-0.089-0.924-0.256l-0.843-0.506l1.151,3.068h8.213L17.257,12.127z',
    viewBox: '0 0 24 24'
  },
  delete: {
    path: 'M6.333,18.611c0,1.039,0.85,1.889,1.889,1.889h7.556c1.039,0,1.889-0.85,1.889-1.889V9.167c0-1.039-0.85-1.889-1.889-1.889 H8.222c-1.039,0-1.889,0.85-1.889,1.889V18.611z M17.667,4.444h-2.361l-0.671-0.671c-0.17-0.17-0.416-0.274-0.661-0.274h-3.948 c-0.246,0-0.491,0.104-0.661,0.274L8.694,4.444H6.333c-0.519,0-0.944,0.425-0.944,0.944s0.425,0.944,0.944,0.944h11.333 c0.519,0,0.944-0.425,0.944-0.944S18.186,4.444,17.667,4.444z',
    viewBox: '0 0 24 24'
  },
  dnd: {
    path: 'M8.078,17.054C9.199,17.928,10.579,18.401,12,18.4c3.529,0,6.4-2.871,6.4-6.4c0.001-1.421-0.472-2.801-1.346-3.922 C17.054,8.078,8.078,17.054,8.078,17.054z M6.946,15.922l8.976-8.976C14.801,6.072,13.421,5.599,12,5.6 C8.467,5.604,5.604,8.467,5.6,12C5.6,13.477,6.103,14.838,6.946,15.922z M12,4c4.411,0,8,3.589,8,8s-3.589,8-8,8s-8-3.589-8-8 S7.589,4,12,4z',
    viewBox: '0 0 24 24'
  },
  edit: {
    path: 'M4,16.667V20h3.333l9.83-9.83L13.83,6.837L4,16.667z M19.74,7.593c0.347-0.347,0.347-0.907,0-1.253l-2.08-2.08 c-0.347-0.347-0.907-0.347-1.253,0l-1.626,1.626l3.333,3.333C18.114,9.219,19.74,7.593,19.74,7.593z',
    viewBox: '0 0 24 24'
  },
  email: {
    path: 'M18.8,5.2H5.2c-0.935,0-1.691,0.765-1.691,1.7L3.5,17.1c0,0.935,0.765,1.7,1.7,1.7h13.6c0.935,0,1.7-0.765,1.7-1.7V6.9 C20.5,5.965,19.735,5.2,18.8,5.2z M18.8,8.6L12,12.85L5.2,8.6V6.9l6.8,4.25l6.8-4.25V8.6z',
    viewBox: '0 0 24 24'
  },
  endCall: {
    path: 'M9.076,13.789l-1.95,2.003c-0.259,0.269-0.687,0.278-0.956,0.019c-0.007-0.006-0.013-0.013-0.019-0.019L4.202,13.79 c-0.269-0.28-0.269-0.722,0-1.002l2.437-2.505c2.848-2.961,7.556-3.053,10.517-0.205c0.07,0.067,0.138,0.135,0.205,0.205 l2.437,2.505c0.27,0.276,0.27,0.725,0,1.002l-1.95,2.003c-0.259,0.269-0.687,0.277-0.956,0.018 c-0.006-0.006-0.012-0.012-0.018-0.018l-1.95-2.003c-0.269-0.28-0.269-0.722,0-1.002l0.487-0.5c-1.949-1.942-4.873-2.004-6.822,0 l0.487,0.5c0.27,0.277,0.27,0.725,0,1.002V13.789z',
    viewBox: '0 0 24 24'
  },
  fileCopy: {
    path: 'M15.273,4H6.545c-0.8,0-1.455,0.655-1.455,1.455v10.182h1.455V5.455h8.727V4z M14.545,6.909l4.364,4.364v7.273 c0,0.8-0.655,1.455-1.455,1.455H9.447C8.647,20,8,19.345,8,18.545L8.007,8.364c0-0.8,0.647-1.455,1.447-1.455H14.545z M13.818,12h4 l-4-4V12z',
    viewBox: '0 0 24 24'
  },
  fullScreenEnter: {
    path: 'M16,5.334V4h4v4h-1.333V6.276l-2.195,2.195l-0.942-0.942l2.195-2.195C17.724,5.334,16,5.334,16,5.334z M7.529,15.528 l0.942,0.942l-2.195,2.195H8V20H4v-4h1.333v1.724L7.529,15.528z M8,5.334H6.276l2.195,2.195L7.529,8.472L5.334,6.276V8H4V4h4V5.334z M14,8.667c0.735,0,1.333,0.598,1.333,1.333v4c0,0.735-0.598,1.333-1.333,1.333h-4c-0.735,0-1.333-0.598-1.333-1.333v-4 c0-0.735,0.598-1.333,1.333-1.333H14z M18.667,17.724V16H20v4h-4v-1.333h1.724l-2.195-2.195l0.942-0.942 C16.471,15.528,18.667,17.724,18.667,17.724z',
    viewBox: '0 0 24 24'
  },
  fullScreenExit: {
    path: 'M10.634,9.267h2.734c0.753,0,1.366,0.613,1.366,1.366v2.733c0,0.753-0.613,1.366-1.366,1.366h-2.733 c-0.753,0-1.366-0.613-1.366-1.366v-2.733C9.267,9.88,9.88,9.267,10.634,9.267z M5.167,7.9h1.767L4,4.967L4.966,4L7.9,6.934V5.167 h1.367v4.1h-4.1C5.167,9.267,5.167,7.9,5.167,7.9z M18.833,14.733V16.1h-1.767L20,19.033L19.034,20L16.1,17.066v1.767h-1.367v-4.1 H18.833z M7.9,17.066L4.967,20L4,19.033L6.934,16.1H5.167v-1.366h4.1v4.1H7.9V17.066z M18.833,7.9v1.367h-4.1v-4.1H16.1v1.767 L19.034,4L20,4.967L17.066,7.9H18.833z',
    viewBox: '0 0 24 24'
  },
  globe: {
    path: 'M12.001,4C7.589,4,4,7.589,4,12.001C4,16.411,7.589,20,12.001,20C16.411,20,20,16.411,20,12.001C20,7.589,16.411,4,12.001,4 z M12,18.166c-1.016-0.997-1.691-2.197-2.044-3.622h4.087C13.69,15.968,13.016,17.169,12,18.166z M9.762,13.477 c-0.061-0.472-0.1-0.959-0.1-1.476c0-0.73,0.067-1.41,0.189-2.052h4.298c0.121,0.641,0.188,1.321,0.188,2.052 c0,0.517-0.039,1.004-0.1,1.476H9.762z M5.067,12.001c0-0.714,0.109-1.403,0.31-2.052h3.392c-0.112,0.651-0.174,1.333-0.174,2.052 c0,0.511,0.039,0.999,0.096,1.476H5.229C5.125,13,5.067,12.507,5.067,12.001z M13.874,8.882h-3.749 c0.382-1.175,0.999-2.19,1.875-3.049C12.876,6.693,13.492,7.707,13.874,8.882z M15.23,9.949h3.393 c0.201,0.649,0.31,1.338,0.31,2.052c0,0.507-0.058,1-0.162,1.476h-3.464c0.057-0.477,0.096-0.965,0.096-1.476 C15.404,11.281,15.342,10.599,15.23,9.949z M18.184,8.882H14.99c-0.42-1.465-1.167-2.722-2.222-3.77 C15.14,5.374,17.15,6.84,18.184,8.882z M11.233,5.112C10.177,6.16,9.429,7.417,9.01,8.882H5.816C6.85,6.84,8.86,5.375,11.233,5.112z M5.556,14.543h3.316c0.381,1.709,1.171,3.163,2.361,4.345C8.643,18.602,6.483,16.883,5.556,14.543z M12.766,18.889 c1.19-1.182,1.979-2.636,2.36-4.345h3.317C17.517,16.883,15.357,18.602,12.766,18.889z',
    viewBox: '0 0 24 24'
  },
  hand: {
    path: 'M17.9,7.9V17c0,1.4-1.1,2.5-2.5,2.5h-4.6c-0.7,0-1.3-0.3-1.8-0.7l-4.9-5C4.2,13.8,5,13,5,13c0.1-0.1,0.3-0.2,0.5-0.2 c0.1,0,0.3,0,0.4,0.1c0,0,2.7,1.5,2.7,1.5V7c0-0.5,0.4-0.9,0.9-0.9c0.5,0,0.9,0.4,0.9,0.9v4.4h0.6V5.4c0-0.5,0.4-0.9,0.9-0.9 c0.5,0,0.9,0.4,0.9,0.9v5.9h0.6V6.1c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9v5.3h0.6V7.9C16.1,7.4,16.5,7,17,7S17.9,7.4,17.9,7.9z',
    viewBox: '0 0 24 24'
  },
  hashtag: {
    path: 'M18.067,10.504L18.5,8.055h-2.209L17.073,4h-2.346l-0.782,4.055h-2.473L12.254,4H9.918L9.136,8.055H6.959l-0.444,2.449 h2.166l-0.549,2.792H5.944L5.5,15.768h2.177L6.863,20h2.336l0.814-4.232h2.473L11.672,20h2.346l0.814-4.232h2.219l0.433-2.471 h-2.209l0.56-2.792H18.067L18.067,10.504z M10.901,10.294h2.779l-0.644,3.224h-2.758L10.901,10.294z',
    viewBox: '0 0 24 24'
  },
  headset: {
    path: 'M19.023,9.504h-0.608c-0.166,0-0.172-0.109-0.177-0.163C17.919,6.344,15.371,4,12.286,4h-0.572 C8.652,4,6.119,6.309,5.771,9.275C5.762,9.351,5.757,9.505,5.617,9.505H4.978c-0.419,0-1.398,0.441-1.398,2.667v1.168 c0,1.651,0.979,2.032,1.398,2.032h2.033c0.419,0,0.763-0.343,0.763-0.762v-4.343c0-0.419-0.343-0.762-0.763-0.762 c0,0-0.096-0.008-0.072-0.178c0.336-2.344,2.339-4.161,4.775-4.161h0.572c2.419,0,4.428,1.79,4.768,4.113 c0.011,0.075,0.052,0.226-0.065,0.226c-0.419,0-0.763,0.343-0.763,0.762v4.343c0,0.419,0.343,0.762,0.763,0.762h0.382 c0.105,0,0.087,0.084,0.078,0.126c-0.311,1.403-1.009,2.994-2.577,2.994h-1.161c-0.119,0-0.148-0.087-0.171-0.128 c-0.188-0.343-0.553-0.576-0.972-0.576h-1.07c-0.612,0-1.108,0.495-1.108,1.106c0,0.611,0.496,1.107,1.108,1.107h1.07 c0.425,0,0.794-0.239,0.98-0.59c0.016-0.031,0.029-0.094,0.155-0.094h1.169c1.065,0,2.489-0.528,3.231-3.046 c0.079-0.268,0.143-0.536,0.195-0.793c0.007-0.035,0.012-0.106,0.122-0.106h0.602c0.419,0,1.398-0.381,1.398-2.032v-1.168 C20.421,9.977,19.441,9.505,19.023,9.504L19.023,9.504z',
    viewBox: '0 0 24 24'
  },
  helpOutline: {
    path: 'M11,18h2v-2h-2V18z M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M12,20c-4.41,0-8-3.59-8-8 s3.59-8,8-8s8,3.59,8,8S16.41,20,12,20z M12,6c-2.21,0-4,1.79-4,4h2c0-1.1,0.9-2,2-2s2,0.9,2,2c0,2-3,1.75-3,5h2c0-2.25,3-2.5,3-5 C16,7.79,14.21,6,12,6z',
    viewBox: '0 0 24 24'
  },
  help: {
    path: 'M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M13,19h-2v-2h2V19z M15.07,11.25l-0.9,0.92 C13.45,12.9,13,13.5,13,15h-2v-0.5c0-1.1,0.45-2.1,1.17-2.83l1.24-1.26C13.78,10.05,14,9.55,14,9c0-1.1-0.9-2-2-2s-2,0.9-2,2H8 c0-2.21,1.79-4,4-4s4,1.79,4,4C16,9.88,15.64,10.68,15.07,11.25z',
    viewBox: '0 0 24 24'
  },
  home: {
    path: 'M10.15,18.77v-4.62h3.696v4.62c0,0.508,0.416,0.924,0.924,0.924h2.772c0.508,0,0.924-0.416,0.924-0.924v-6.467h1.571 c0.425,0,0.628-0.527,0.305-0.804l-7.724-6.957c-0.351-0.314-0.887-0.314-1.238,0l-7.724,6.957c-0.314,0.277-0.12,0.804,0.305,0.804 h1.571v6.467c0,0.508,0.416,0.924,0.924,0.924h2.772C9.734,19.694,10.15,19.278,10.15,18.77z',
    viewBox: '0 0 24 24'
  },
  hourglass: {
    path: 'M17.023,18.87v-1.696c0-1.998-1.48-3.193-2.902-4.359c-0.197-0.16-0.446-0.466-0.446-0.931c0-0.465,0.225-0.92,0.446-1.114 c1.384-1.215,2.902-2.361,2.902-4.359V5.13h0.301c0.45,0,0.815-0.365,0.815-0.815l0,0c0-0.45-0.365-0.815-0.815-0.815H6.676 c-0.45,0-0.815,0.365-0.815,0.815l0,0c0,0.45,0.365,0.815,0.815,0.815h0.301v1.281c0,1.998,1.518,3.144,2.902,4.359 c0.221,0.194,0.446,0.648,0.446,1.114c0,0.466-0.25,0.771-0.446,0.931c-1.422,1.166-2.902,2.361-2.902,4.359v1.696H6.676 c-0.45,0-0.815,0.365-0.815,0.815l0,0c0,0.45,0.365,0.815,0.815,0.815h10.649c0.45,0,0.815-0.365,0.815-0.815l0,0l0,0 c0-0.45-0.365-0.815-0.815-0.815H17.023z M8.539,6.41V5.129h6.921V6.41c0,0.281-0.058,0.538-0.167,0.786 c-0.109,0.247-0.269,0.485-0.474,0.727H9.18C8.769,7.438,8.539,6.97,8.539,6.41L8.539,6.41z M12.832,17.346 c-0.457-0.186-1.206-0.186-1.664,0l-2.628,1.07v-1.242c0-1.131,0.861-1.894,2.267-3.046l0.037-0.03 c0.533-0.437,0.88-1.045,0.997-1.714c0.105,0.024,0.213,0.024,0.318,0c0.117,0.669,0.463,1.277,0.996,1.713l0.038,0.031 c1.406,1.152,2.267,1.915,2.267,3.046v1.242L12.832,17.346L12.832,17.346z',
    viewBox: '0 0 24 24'
  },
  informationOutline: {
    path: 'M11,7h2v2h-2V7z M11,11h2v6h-2V11z M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M12,20 c-4.41,0-8-3.59-8-8s3.59-8,8-8s8,3.59,8,8S16.41,20,12,20z',
    viewBox: '0 0 24 24'
  },
  information: {
    path: 'M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M13,17h-2v-6h2V17z M13,9h-2V7h2V9z',
    viewBox: '0 0 24 24'
  },
  keypad: {
    path: 'M8.652,8C8.96,8,9.21,8.255,9.21,8.569v2.272c0,0.313-0.25,0.568-0.558,0.568H6.419c-0.308,0-0.558-0.254-0.558-0.568V8.568 C5.862,8.255,6.112,8,6.419,8L8.652,8L8.652,8z M13.116,8c0.308,0,0.558,0.255,0.558,0.569v2.272c0,0.313-0.25,0.568-0.558,0.568 h-2.232c-0.308,0-0.558-0.254-0.558-0.568V8.568c0-0.313,0.25-0.568,0.558-0.568L13.116,8L13.116,8z M17.581,8 c0.308,0,0.558,0.255,0.558,0.569v2.272c0,0.313-0.25,0.568-0.558,0.568h-2.232c-0.308,0-0.558-0.254-0.558-0.568V8.568 c0-0.313,0.25-0.568,0.558-0.568L17.581,8L17.581,8z M8.65,3.5c0.308,0,0.558,0.255,0.558,0.569v2.272 c0,0.313-0.25,0.568-0.558,0.568H6.419c-0.308,0-0.558-0.254-0.558-0.568V4.068c0-0.313,0.25-0.568,0.558-0.568L8.65,3.5L8.65,3.5z M13.114,3.5c0.308,0,0.558,0.255,0.558,0.569v2.272c0,0.313-0.25,0.568-0.558,0.568h-2.23c-0.308,0-0.558-0.254-0.558-0.568V4.068 c0-0.313,0.25-0.568,0.558-0.568L13.114,3.5L13.114,3.5z M17.579,3.5c0.308,0,0.558,0.255,0.558,0.569v2.272 c0,0.313-0.25,0.568-0.558,0.568h-2.23c-0.308,0-0.558-0.254-0.558-0.568V4.068c0-0.313,0.25-0.568,0.558-0.568L17.579,3.5 L17.579,3.5z M8.652,12.546c0.308,0,0.558,0.254,0.558,0.568v2.273c0,0.313-0.25,0.568-0.558,0.568H6.419 c-0.308,0-0.558-0.254-0.558-0.568v-2.273c0-0.313,0.25-0.568,0.558-0.568C6.419,12.546,8.652,12.546,8.652,12.546z M13.116,12.546 c0.308,0,0.558,0.254,0.558,0.568v2.273c0,0.313-0.25,0.568-0.558,0.568h-2.232c-0.308,0-0.558-0.254-0.558-0.568v-2.273 c0-0.313,0.25-0.568,0.558-0.568H13.116z M13.116,17.091c0.308,0,0.558,0.254,0.558,0.568v2.273c0,0.313-0.25,0.568-0.558,0.568 h-2.232c-0.308,0-0.558-0.254-0.558-0.568v-2.273c0-0.313,0.25-0.568,0.558-0.568L13.116,17.091L13.116,17.091z M15.349,12.546 h2.232c0.308,0,0.558,0.254,0.558,0.568v2.273c0,0.313-0.25,0.568-0.558,0.568h-2.232c-0.308,0-0.558-0.254-0.558-0.568v-2.273 C14.791,12.801,15.041,12.546,15.349,12.546z',
    viewBox: '0 0 24 24'
  },
  launch: {
    path: 'M17.333,18.222H6.667c-0.489,0-0.889-0.4-0.889-0.889V6.667c0-0.489,0.4-0.889,0.889-0.889h4.444 C11.6,5.778,12,5.378,12,4.889S11.6,4,11.111,4H5.778C4.791,4,4,4.8,4,5.778v12.444C4,19.2,4.8,20,5.778,20h12.444 C19.2,20,20,19.2,20,18.222v-5.333C20,12.4,19.6,12,19.111,12s-0.889,0.4-0.889,0.889v4.444 C18.222,17.822,17.822,18.222,17.333,18.222z M13.778,4.889c0,0.489,0.4,0.889,0.889,0.889h2.302l-8.116,8.116 c-0.347,0.347-0.347,0.907,0,1.253s0.907,0.347,1.253,0l8.116-8.116v2.302c0,0.489,0.4,0.889,0.889,0.889S20,9.822,20,9.333V4 h-5.333C14.178,4,13.778,4.4,13.778,4.889z',
    viewBox: '0 0 24 24'
  },
  lightningOutline: {
    path: 'M18.064,4h-8.038l-4.09,8.302l4.301,0.076c-0.15,0.411-2.659,7.614-2.651,7.622L18.029,8.641l-4.25-0.036L18.064,4z M15.768,9.622l-5.663,6.16c0.523-1.502,0.995-2.851,1.071-3.062l0.479-1.317L7.53,11.33L10.648,5h5.119L11.5,9.586L15.768,9.622z',
    viewBox: '0 0 24 24'
  },
  lightning: {
    path: 'M5.936,12.302l4.301,0.076c-0.15,0.411-2.659,7.614-2.651,7.622L18.029,8.641l-4.25-0.036L18.064,4h-8.038L5.936,12.302z',
    viewBox: '0 0 24 24'
  },
  link: {
    path: 'M13.933,10.067c1.696,1.696,1.806,4.392,0.324,6.214c-0.207,0.257-0.092,0.128-2.82,2.856c-1.816,1.816-4.757,1.818-6.574,0 c-1.817-1.816-1.817-4.756,0-6.574c1.088-1.088,1.721-1.723,2.105-2.107c0.248-0.247,0.675-0.078,0.68,0.272 c0.006,0.423,0.059,0.844,0.158,1.256c0.032,0.134-0.009,0.275-0.106,0.372l-1.522,1.522c-1.088,1.088-1.092,2.852,0,3.945 c1.088,1.088,2.852,1.092,3.945,0l2.497-2.497c1.086-1.087,1.088-2.856,0-3.944c-0.22-0.221-0.477-0.403-0.757-0.539 c-0.153-0.074-0.238-0.241-0.218-0.41c0.045-0.369,0.209-0.727,0.492-1.01l0.145-0.145c0.12-0.12,0.305-0.153,0.457-0.076 C13.169,9.419,13.573,9.707,13.933,10.067z M19.137,4.863c-1.817-1.818-4.758-1.816-6.574,0C9.836,7.591,9.95,7.462,9.743,7.719 c-1.482,1.822-1.373,4.518,0.324,6.214c0.36,0.36,0.765,0.648,1.196,0.865c0.152,0.076,0.336,0.044,0.457-0.076l0.145-0.145 c0.283-0.283,0.447-0.64,0.492-1.009c0.021-0.169-0.064-0.336-0.218-0.41c-0.281-0.136-0.537-0.318-0.757-0.539 c-1.088-1.088-1.086-2.858,0-3.944l2.497-2.497c1.093-1.092,2.856-1.088,3.945,0c1.092,1.093,1.088,2.856,0,3.945L16.3,11.644 c-0.097,0.097-0.138,0.238-0.106,0.372c0.098,0.412,0.151,0.833,0.158,1.256c0.005,0.35,0.432,0.519,0.68,0.272 c0.384-0.384,1.017-1.019,2.105-2.107C20.955,9.619,20.954,6.679,19.137,4.863z',
    viewBox: '0 0 24 24'
  },
  micOff: {
    path: 'M9.377,16.697l1.08-1.08c0.49,0.167,1.012,0.257,1.543,0.257c2.366,0,4.543-1.769,4.543-4.295H18 c0,2.872-2.331,5.246-5.143,5.659V20h-1.714v-2.762C10.53,17.148,9.935,16.965,9.377,16.697z M7.098,14.827 C6.391,13.892,6.006,12.753,6,11.58h1.457c0,0.842,0.242,1.6,0.653,2.237l-1.012,1.012V14.827z M11.969,14.105l2.594-2.594v0.068 c0,1.398-1.14,2.526-2.563,2.526H11.969z M9.556,12.37c-0.085-0.255-0.128-0.522-0.127-0.791V6.526C9.429,5.128,10.577,4,12,4 s2.571,1.128,2.571,2.526l-0.001,0.83L9.556,12.37z M19.111,4L20,4.889L4.889,20L4,19.111L19.111,4z',
    viewBox: '0 0 24 24'
  },
  mic: {
    path: 'M18,11.579h-1.457c0,2.526-2.177,4.295-4.543,4.295s-4.543-1.769-4.543-4.295H6c0,2.872,2.331,5.246,5.143,5.659V20h1.714 v-2.762C15.67,16.825,18,14.45,18,11.578 M12,14.105c1.423,0,2.563-1.128,2.563-2.526l0.008-5.053C14.571,5.128,13.423,4,12,4 S9.429,5.128,9.429,6.526v5.053C9.429,12.977,10.577,14.105,12,14.105',
    viewBox: '0 0 24 24'
  },
  more: {
    path: 'M12.019,7.2c-0.883,0.022-1.618-0.677-1.639-1.561s0.677-1.618,1.561-1.639C11.968,4,11.994,4,12.02,4.001 c0.883,0.022,1.582,0.756,1.561,1.639C13.559,6.493,12.873,7.179,12.019,7.2z M12.019,13.6c-0.884,0-1.6-0.716-1.6-1.6 s0.716-1.6,1.6-1.6c0.884,0,1.6,0.716,1.6,1.6S12.904,13.6,12.019,13.6z M12.019,20c-0.883,0.022-1.618-0.677-1.639-1.561 c-0.022-0.883,0.677-1.618,1.561-1.639c0.026-0.001,0.052-0.001,0.079,0c0.883,0.022,1.582,0.756,1.561,1.639 C13.559,19.292,12.873,19.979,12.019,20z',
    viewBox: '0 0 24 24'
  },
  palette: {
    path: 'M12,3c-4.97,0-9,4.03-9,9s4.03,9,9,9c0.83,0,1.5-0.67,1.5-1.5c0-0.39-0.15-0.74-0.39-1.01c-0.23-0.26-0.38-0.61-0.38-0.99 c0-0.83,0.67-1.5,1.5-1.5H16c2.76,0,5-2.24,5-5C21,6.58,16.97,3,12,3z M6.5,12C5.67,12,5,11.33,5,10.5S5.67,9,6.5,9S8,9.67,8,10.5 S7.33,12,6.5,12z M9.5,8C8.67,8,8,7.33,8,6.5S8.67,5,9.5,5S11,5.67,11,6.5S10.33,8,9.5,8z M14.5,8C13.67,8,13,7.33,13,6.5 S13.67,5,14.5,5S16,5.67,16,6.5S15.33,8,14.5,8z M17.5,12c-0.83,0-1.5-0.67-1.5-1.5S16.67,9,17.5,9S19,9.67,19,10.5 S18.33,12,17.5,12z',
    viewBox: '0 0 24 24'
  },
  people: {
    path: 'M16.096,13.929c2.594,0,4.404,1.38,4.404,3.355v0.559h-8.808v-0.56C11.692,15.309,13.503,13.929,16.096,13.929 L16.096,13.929z M11.622,8.906c0,1.516-1.214,2.75-2.707,2.75c-1.493,0-2.707-1.235-2.707-2.75s1.214-2.75,2.707-2.75 S11.622,7.39,11.622,8.906z M18.297,10.574c0,1.234-0.988,2.237-2.203,2.237s-2.203-1.004-2.203-2.237s0.988-2.237,2.203-2.237 C17.31,8.338,18.297,9.342,18.297,10.574z M11.926,13.646c-1.109,0.866-1.785,2.123-1.785,3.639v0.559H3.5v-0.687 c0-2.429,2.227-4.126,5.415-4.126C10.063,13.032,11.086,13.252,11.926,13.646L11.926,13.646z',
    viewBox: '0 0 24 24'
  },
  personLock: {
    path: 'M22,17v-0.5c0-1.38-1.12-2.5-2.5-2.5S17,15.12,17,16.5V17c-0.55,0-1,0.45-1,1v4c0,0.55,0.45,1,1,1h5c0.55,0,1-0.45,1-1v-4 C23,17.45,22.55,17,22,17z M21,17h-3v-0.5c0-0.83,0.67-1.5,1.5-1.5s1.5,0.67,1.5,1.5V17z M15,18v2H4.5v-0.941 c0-3.325,3.084-5.647,7.5-5.647c1.813,0,3.395,0.396,4.637,1.087c-0.356,0.508-0.586,1.11-0.63,1.764C15.406,16.609,15,17.258,15,18 z M8.25,7.765C8.25,5.69,9.932,4,12,4s3.75,1.69,3.75,3.765c0,2.076-1.682,3.765-3.75,3.765C9.933,11.53,8.25,9.84,8.25,7.765z',
    viewBox: '0 0 24 24'
  },
  personPlus: {
    path: 'M15.75,7.765c0,2.076-1.682,3.765-3.75,3.765c-2.067,0-3.75-1.69-3.75-3.765S9.932,4,12,4S15.75,5.69,15.75,7.765z M12,13.412c4.417,0,7.5,2.322,7.5,5.647V20h-15v-0.941C4.5,15.734,7.584,13.412,12,13.412z M23,10.75h-2.75V8h-1v2.75H16.5v1h2.75 v2.75h1v-2.75H23V10.75z',
    viewBox: '0 0 24 24'
  },
  person: {
    path: 'M15.75,7.765c0,2.076-1.682,3.765-3.75,3.765c-2.067,0-3.75-1.69-3.75-3.765S9.932,4,12,4S15.75,5.69,15.75,7.765z M12,13.412c4.417,0,7.5,2.322,7.5,5.647V20h-15v-0.941C4.5,15.734,7.584,13.412,12,13.412z',
    viewBox: '0 0 24 24'
  },
  pin: {
    path: 'M12.585,13.712l0,4.159c0,0.75-0.204,1.486-0.59,2.129c-0.386-0.643-0.59-1.379-0.59-2.129l0-4.159H12.585z M8.312,13.097 l7.376,0c0.461,0,0.834-0.373,0.834-0.834c0-0.221-0.088-0.434-0.244-0.59l-2.196-1.918V5.18h0.868c0.326,0,0.59-0.264,0.59-0.59 c0-0.326-0.264-0.59-0.59-0.59H9.051c-0.326,0-0.59,0.264-0.59,0.59c0,0.326,0.264,0.59,0.59,0.59l0.868,0v4.575l-2.196,1.918 c-0.156,0.156-0.245,0.369-0.244,0.59C7.478,12.724,7.851,13.097,8.312,13.097z',
    viewBox: '0 0 24 24'
  },
  pipOff: {
    path: 'M10.5,11.5h-4v-3h4V11.5z M19.5,8.419l-1,0.726V16.5H8.373l-1.377,1H19.5V8.419z M5.5,7.5h10.126l1.377-1H4.5v9.081l1-0.726 V7.5z M20,6.82L19.393,6L4,17.18L4.607,18L20,6.82z',
    viewBox: '0 0 24 24'
  },
  pip: {
    path: 'M4.5,6.5v11h15v-11H4.5z M18.5,16.5h-13v-9h13V16.5z M10.5,11.5h-4v-3h4V11.5z',
    viewBox: '0 0 24 24'
  },
  popout: {
    path: 'M19.691,15.676h-0.615c-0.169,0-0.307-0.137-0.307-0.307c0-0.169,0.137-0.307,0.307-0.307h0.308v-0.306 c0-0.169,0.137-0.307,0.307-0.307h0.003c0.169,0,0.307,0.137,0.307,0.307v0.612c0,0.168-0.137,0.307-0.307,0.307H19.691 L19.691,15.676z M19.691,5.264h0.003C19.863,5.264,20,5.401,20,5.57v0.612c0,0.168-0.137,0.307-0.307,0.307h-0.003 c-0.169,0-0.307-0.137-0.307-0.307l0,0V5.876h-0.309c-0.162-0.009-0.29-0.142-0.29-0.306c0-0.164,0.128-0.297,0.29-0.306l0.001,0 H19.691L19.691,5.264z M7.385,5.264H8c0.005,0,0.01,0,0.016,0c0.169,0,0.307,0.137,0.307,0.307c0,0.169-0.137,0.307-0.307,0.307 c-0.006,0-0.011,0-0.017,0l0.001,0H7.692v0.307c0,0.168-0.137,0.307-0.307,0.307H7.382c-0.169,0-0.306-0.138-0.306-0.307l0,0l0,0 V5.57c0-0.169,0.137-0.307,0.306-0.307L7.385,5.264L7.385,5.264z M4.611,12.001h8.006c0.339,0,0.613,0.275,0.613,0.612v5.512l0,0 c0,0.338-0.274,0.612-0.612,0.612c0,0-0.001,0-0.001,0H4.612C4.274,18.737,4,18.463,4,18.125l0,0v-5.512 C4,12.275,4.275,12.001,4.611,12.001L4.611,12.001z M5.23,13.226v4.286H12v-4.286H5.23L5.23,13.226z M7.383,9.55h0.003 c0.168,0,0.307,0.137,0.307,0.307v1.224c0,0.168-0.137,0.307-0.307,0.307H7.383c-0.169,0-0.306-0.138-0.306-0.307l0,0l0,0V9.857 C7.077,9.688,7.214,9.551,7.383,9.55L7.383,9.55z M7.383,7.1h0.003c0.168,0,0.307,0.138,0.307,0.307v1.226 c0,0.168-0.137,0.307-0.307,0.307H7.383c-0.169,0-0.306-0.138-0.306-0.307l0,0l0,0V7.407c0-0.168,0.137-0.306,0.306-0.306V7.1z M19.691,7.1h0.003C19.863,7.1,20,7.238,20,7.406v1.226c0,0.168-0.137,0.307-0.307,0.307h-0.003c-0.169,0-0.307-0.137-0.307-0.307 l0,0V7.407c0-0.168,0.137-0.306,0.307-0.306V7.1z M19.691,9.55h0.003C19.863,9.55,20,9.687,20,9.857v1.224 c0,0.168-0.137,0.307-0.307,0.307h-0.003c-0.169,0-0.307-0.137-0.307-0.307l0,0V9.857C19.384,9.688,19.522,9.551,19.691,9.55 L19.691,9.55z M19.691,12h0.003C19.863,12,20,12.137,20,12.306v1.224c0,0.169-0.137,0.307-0.307,0.307h-0.003 c-0.169,0-0.307-0.137-0.307-0.307l0,0v-1.224C19.384,12.137,19.522,12,19.691,12z M14.152,5.263h1.234 c0.162,0.009,0.29,0.142,0.29,0.306s-0.128,0.297-0.29,0.306l-0.001,0h-1.234c-0.005,0-0.01,0-0.016,0 c-0.169,0-0.307-0.137-0.307-0.307s0.137-0.307,0.307-0.307C14.142,5.263,14.148,5.263,14.152,5.263L14.152,5.263L14.152,5.263z M11.691,5.263h1.234c0.162,0.009,0.29,0.142,0.29,0.306s-0.128,0.297-0.29,0.306l-0.001,0h-1.234 c-0.162-0.009-0.29-0.142-0.29-0.306C11.4,5.405,11.529,5.272,11.691,5.263L11.691,5.263L11.691,5.263z M9.229,5.264h1.234 c0.162,0.009,0.29,0.142,0.29,0.306s-0.128,0.297-0.29,0.306l-0.001,0H9.229c-0.162-0.009-0.29-0.142-0.29-0.306 C8.939,5.406,9.067,5.273,9.229,5.264C9.229,5.264,9.229,5.264,9.229,5.264z M16.614,5.264h1.234c0.005,0,0.01,0,0.016,0 c0.169,0,0.307,0.137,0.307,0.307c0,0.169-0.137,0.307-0.307,0.307c-0.006,0-0.011,0-0.017,0l0.001,0h-1.233 c-0.162-0.009-0.29-0.142-0.29-0.306C16.324,5.406,16.453,5.273,16.614,5.264L16.614,5.264L16.614,5.264z M16.614,15.063h1.234 c0.169,0,0.307,0.137,0.307,0.307c0,0.169-0.137,0.307-0.307,0.307h-1.233c-0.169,0-0.307-0.137-0.307-0.307 C16.308,15.2,16.445,15.063,16.614,15.063L16.614,15.063L16.614,15.063z M14.152,15.063h1.234c0.169,0,0.307,0.137,0.307,0.307 c0,0.169-0.137,0.307-0.307,0.307h-1.234c-0.169,0-0.307-0.137-0.307-0.307C13.846,15.2,13.983,15.063,14.152,15.063L14.152,15.063z M15.062,10.776l-0.6-0.598l2.244-2.233h-1.096V7.101h2.545v2.532h-0.849V8.542l-2.245,2.233L15.062,10.776z',
    viewBox: '0 0 24 24'
  },
  recordStop: {
    path: 'M4,4h16v16H4V4z',
    viewBox: '0 0 24 24'
  },
  record: {
    path: 'M4,12c0-4.418,3.582-8,8-8s8,3.582,8,8s-3.582,8-8,8S4,16.418,4,12z M19,12c0-3.866-3.134-7-7-7s-7,3.134-7,7s3.134,7,7,7 S19,15.866,19,12z M12,15.79c-2.093,0-3.79-1.697-3.79-3.79S9.907,8.21,12,8.21s3.79,1.697,3.79,3.79S14.093,15.79,12,15.79z',
    viewBox: '0 0 24 24'
  },
  return: {
    path: 'M15.88,6.4h-4.121v1.634h4.121c1.363,0,2.472,1.1,2.472,2.451s-1.109,2.452-2.472,2.452H7.155l1.89-1.873L7.879,9.908 L4,13.754L7.879,17.6l1.166-1.156l-1.89-1.873h8.725c2.272,0,4.12-1.833,4.12-4.085S18.151,6.4,15.88,6.4z',
    viewBox: '0 0 24 24'
  },
  roomSystem: {
    path: 'M18.985,8.237c-0.001-0.009-0.008-0.017-0.008-0.027c-0.03-0.903-0.223-1.782-0.594-2.61 c-0.155-0.351-0.566-0.509-0.917-0.352c-0.351,0.157-0.508,0.568-0.351,0.917c0.208,0.465,0.343,0.95,0.416,1.447h-1.294 C15.914,5.567,14.139,4,12.001,4S8.08,5.567,7.755,7.612H6.464c0.074-0.497,0.207-0.982,0.415-1.447 c0.156-0.351-0.002-0.761-0.352-0.917C6.174,5.092,5.766,5.25,5.609,5.601C5.238,6.436,5.043,7.322,5.016,8.236v0.001 C5.008,8.253,5.008,8.26,5.008,8.275v0.111c0,0.019-0.003,0.039-0.003,0.059c0,3.499,2.589,6.398,5.951,6.904 c-2.355,0.319-4.482,1.705-5.711,3.776c-0.107,0.179-0.108,0.401-0.007,0.583C5.341,19.888,5.533,20,5.745,20h12.522 c0.32,0,0.582-0.259,0.582-0.581c0-0.155-0.063-0.294-0.159-0.399c-1.239-2.014-3.336-3.359-5.651-3.671 c3.363-0.505,5.953-3.404,5.953-6.905c0-0.013-0.003-0.026-0.003-0.039c0.002-0.005,0.005-0.009,0.007-0.015V8.275 C18.994,8.26,18.994,8.252,18.985,8.237L18.985,8.237L18.985,8.237z M10.155,7.612c0.279-0.75,0.997-1.274,1.846-1.274 c0.841,0,1.559,0.525,1.844,1.274c0.079,0.215,0.125,0.448,0.125,0.695c0,0.247-0.047,0.479-0.125,0.695 c-0.284,0.748-1.003,1.281-1.844,1.281c-0.849,0-1.567-0.533-1.846-1.281c-0.084-0.217-0.13-0.448-0.13-0.695 C10.025,8.06,10.071,7.828,10.155,7.612C10.155,7.612,10.155,7.612,10.155,7.612z M11.998,14.045c-2.902,0-5.292-2.217-5.574-5.044 h1.331c0.325,2.046,2.108,3.611,4.246,3.611s3.913-1.567,4.236-3.611h1.335C17.291,11.829,14.898,14.045,11.998,14.045 C11.998,14.045,11.998,14.045,11.998,14.045z',
    viewBox: '0 0 24 24'
  },
  search: {
    path: 'M15.755,14.255h-0.79l-0.28-0.27c0.98-1.14,1.57-2.62,1.57-4.23c0-3.59-2.91-6.5-6.5-6.5s-6.5,2.91-6.5,6.5 s2.91,6.5,6.5,6.5c1.61,0,3.09-0.59,4.23-1.57l0.27,0.28v0.79l5,4.99l1.49-1.49L15.755,14.255z M9.755,14.255 c-2.49,0-4.5-2.01-4.5-4.5s2.01-4.5,4.5-4.5s4.5,2.01,4.5,4.5S12.245,14.255,9.755,14.255z',
    viewBox: '0 0 24 24'
  },
  send: {
    path: 'M20.139,4.372L3.647,11.824c-0.089,0.04-0.146,0.126-0.147,0.222c-0.001,0.095,0.054,0.183,0.142,0.225l4.667,2.228 c0.086,0.041,0.188,0.032,0.264-0.024l4.538-3.298l-3.563,3.563C9.498,14.79,9.473,14.86,9.478,14.93l0.355,4.492 c0.008,0.099,0.077,0.185,0.174,0.216c0.026,0.009,0.053,0.012,0.079,0.012c0.073,0,0.143-0.03,0.192-0.086l2.477-2.791l3.062,1.423 c0.066,0.031,0.143,0.032,0.211,0.004c0.067-0.029,0.119-0.084,0.141-0.152l4.319-13.376c0.03-0.094,0.001-0.196-0.075-0.26 S20.23,4.332,20.139,4.372L20.139,4.372z',
    viewBox: '0 0 24 24'
  },
  settingsOutline: {
    path: 'M12,8.25c-2.071,0-3.75,1.679-3.75,3.75s1.679,3.75,3.75,3.75s3.75-1.679,3.75-3.75S14.071,8.25,12,8.25z M12,14.75 c-1.517,0-2.75-1.233-2.75-2.75S10.483,9.25,12,9.25s2.75,1.233,2.75,2.75S13.516,14.75,12,14.75z M18.958,13.757l-0.521-0.301 c-0.235-0.136-0.365-0.398-0.33-0.667c0.068-0.525,0.068-1.059,0-1.584c-0.035-0.27,0.095-0.531,0.33-0.667l0.516-0.298 c0.449-0.259,0.638-0.817,0.439-1.296c-0.271-0.651-0.626-1.266-1.057-1.827c-0.198-0.257-0.498-0.405-0.823-0.405 c-0.182,0-0.361,0.048-0.519,0.139l-0.512,0.296c-0.103,0.059-0.219,0.09-0.337,0.09c-0.147,0-0.292-0.049-0.409-0.139 c-0.42-0.323-0.881-0.589-1.37-0.791c-0.252-0.104-0.415-0.347-0.415-0.62V5.097c0-0.519-0.388-0.961-0.903-1.029 C12.703,4.023,12.348,4,11.997,4c-0.353,0-0.707,0.023-1.054,0.068c-0.515,0.067-0.903,0.51-0.903,1.029v0.594 c0,0.272-0.162,0.515-0.413,0.619c-0.488,0.204-0.95,0.471-1.372,0.792C8.139,7.192,7.994,7.241,7.848,7.241 c-0.117,0-0.233-0.031-0.336-0.091L7.001,6.854C6.842,6.762,6.663,6.714,6.482,6.714c-0.325,0-0.625,0.147-0.822,0.404 c-0.431,0.56-0.786,1.175-1.057,1.828c-0.199,0.479-0.01,1.036,0.439,1.296l0.517,0.298c0.235,0.136,0.365,0.398,0.33,0.667 c-0.068,0.525-0.068,1.059,0,1.584c0.035,0.27-0.095,0.531-0.33,0.667l-0.517,0.298c-0.449,0.259-0.638,0.817-0.439,1.296 c0.271,0.651,0.626,1.266,1.057,1.827c0.198,0.257,0.498,0.405,0.823,0.405c0.182,0,0.361-0.048,0.518-0.139l0.513-0.297 c0.102-0.059,0.218-0.09,0.336-0.09c0.147,0,0.292,0.049,0.409,0.139c0.419,0.322,0.88,0.589,1.37,0.791 c0.252,0.104,0.415,0.347,0.415,0.62v0.593c0,0.519,0.388,0.961,0.902,1.029C11.293,19.977,11.647,20,11.999,20 s0.706-0.023,1.054-0.068c0.514-0.068,0.902-0.51,0.902-1.029v-0.594c0-0.272,0.162-0.515,0.413-0.619 c0.489-0.204,0.951-0.471,1.372-0.793c0.116-0.088,0.261-0.137,0.407-0.137c0.117,0,0.233,0.031,0.336,0.09l0.515,0.297 c0.158,0.091,0.337,0.139,0.519,0.139c0.325,0,0.625-0.147,0.822-0.404c0.432-0.561,0.788-1.177,1.059-1.83 C19.596,14.573,19.407,14.016,18.958,13.757z M17.547,16.271l-0.563-0.288c-0.254-0.146-0.543-0.225-0.835-0.225 c-0.363,0-0.723,0.122-1.013,0.342c-0.355,0.271-0.742,0.495-1.151,0.666c-0.625,0.26-1.028,0.866-1.028,1.542v0.594 C12.622,18.98,12.311,19,11.999,19s-0.623-0.02-0.925-0.06l-0.031-0.63c0-0.68-0.406-1.286-1.035-1.545 c-0.406-0.167-0.791-0.39-1.141-0.659C8.577,15.883,8.216,15.76,7.85,15.76c-0.292,0-0.58,0.077-0.833,0.223L6.5,16.281 c-0.425-0.5-0.736-1.04-0.974-1.61l0.532-0.345c0.586-0.338,0.909-0.99,0.822-1.661c-0.057-0.441-0.057-0.888,0-1.328 c0.086-0.672-0.236-1.324-0.822-1.662L5.541,9.376c0.221-0.617,0.532-1.155,0.911-1.647l0.56,0.287 c0.253,0.147,0.543,0.225,0.837,0.225c0.363,0,0.723-0.122,1.013-0.342c0.354-0.27,0.741-0.494,1.152-0.666 c0.623-0.259,1.027-0.865,1.027-1.542V5.097C11.376,5.02,11.687,5,11.997,5c0.309,0,0.619,0.02,0.923,0.06l0.033,0.626 c0,0.679,0.405,1.285,1.032,1.544c0.407,0.167,0.792,0.39,1.144,0.66c0.292,0.224,0.653,0.346,1.018,0.346 c0.291,0,0.58-0.077,0.834-0.223l0.515-0.298c0.425,0.5,0.736,1.038,0.975,1.611l-0.533,0.345c-0.585,0.337-0.908,0.989-0.822,1.661 c0.057,0.441,0.057,0.887,0,1.327c-0.086,0.673,0.237,1.325,0.823,1.663l0.52,0.3C18.237,15.242,17.925,15.781,17.547,16.271z',
    viewBox: '0 0 24 24'
  },
  settings: {
    path: 'M18.958,13.757l-0.521-0.301c-0.235-0.136-0.365-0.398-0.33-0.667c0.068-0.525,0.068-1.059,0-1.584 c-0.035-0.27,0.095-0.531,0.33-0.667l0.516-0.298c0.449-0.259,0.638-0.817,0.439-1.296c-0.271-0.651-0.626-1.266-1.057-1.827 c-0.198-0.257-0.498-0.405-0.823-0.405c-0.182,0-0.361,0.048-0.519,0.139l-0.512,0.296c-0.103,0.059-0.219,0.09-0.337,0.09 c-0.147,0-0.292-0.049-0.409-0.139c-0.42-0.323-0.881-0.589-1.37-0.791c-0.252-0.104-0.415-0.347-0.415-0.62V5.097 c0-0.519-0.388-0.961-0.903-1.029C12.703,4.023,12.348,4,11.997,4c-0.353,0-0.707,0.023-1.054,0.068 c-0.515,0.067-0.903,0.51-0.903,1.029v0.594c0,0.272-0.162,0.515-0.413,0.619c-0.488,0.204-0.95,0.471-1.372,0.792 C8.139,7.192,7.994,7.241,7.848,7.241c-0.117,0-0.233-0.031-0.336-0.091L7.001,6.854C6.842,6.762,6.663,6.714,6.482,6.714 c-0.325,0-0.625,0.147-0.822,0.404c-0.431,0.56-0.786,1.175-1.057,1.828c-0.199,0.479-0.01,1.036,0.439,1.296l0.517,0.298 c0.235,0.136,0.365,0.398,0.33,0.667c-0.068,0.525-0.068,1.059,0,1.584c0.035,0.27-0.095,0.531-0.33,0.667l-0.517,0.298 c-0.449,0.259-0.638,0.817-0.439,1.296c0.271,0.651,0.626,1.266,1.057,1.827c0.198,0.257,0.498,0.405,0.823,0.405 c0.182,0,0.361-0.048,0.518-0.139l0.513-0.297c0.102-0.059,0.218-0.09,0.336-0.09c0.147,0,0.292,0.049,0.409,0.139 c0.419,0.322,0.88,0.589,1.37,0.791c0.252,0.104,0.415,0.347,0.415,0.62v0.593c0,0.519,0.388,0.961,0.902,1.029 C11.293,19.977,11.647,20,11.999,20s0.706-0.023,1.054-0.068c0.514-0.068,0.902-0.51,0.902-1.029v-0.594 c0-0.272,0.162-0.515,0.413-0.619c0.489-0.204,0.951-0.471,1.372-0.793c0.116-0.088,0.261-0.137,0.407-0.137 c0.117,0,0.233,0.031,0.336,0.09l0.515,0.297c0.158,0.091,0.337,0.139,0.519,0.139c0.325,0,0.625-0.147,0.822-0.404 c0.432-0.561,0.788-1.177,1.059-1.83C19.596,14.573,19.407,14.016,18.958,13.757z M12,14.75c-1.517,0-2.75-1.233-2.75-2.75 S10.483,9.25,12,9.25s2.75,1.233,2.75,2.75S13.516,14.75,12,14.75z',
    viewBox: '0 0 24 24'
  },
  shareScreen: {
    path: 'M11.346,6.533L9.842,8.067L8.926,7.133L12,4l3.074,3.133l-0.916,0.934l-1.504-1.534v5.734h-1.308V6.533z M17.886,15.2 l1.046,3.267c0.13,0.4,0.065,0.8-0.13,1.066c-0.213,0.293-0.554,0.466-0.916,0.467H6.114c-0.392,0-0.719-0.2-0.915-0.467 c-0.196-0.333-0.262-0.666-0.131-1.066L6.114,15.2V9.333c0-0.4,0.262-0.666,0.654-0.666H8.73V10H7.422v4.667h9.156V10H15.27V8.667 h1.962c0.392,0,0.654,0.266,0.654,0.666V15.2z M10.692,16.667V18h2.616v-1.333H10.692z',
    viewBox: '0 0 24 24'
  },
  speaker: {
    path: 'M12.882,6.334v11.333c0,0.226-0.132,0.432-0.338,0.526c-0.077,0.035-0.159,0.052-0.24,0.052 c-0.136,0-0.271-0.048-0.379-0.141l-3.863-3.341H4.578C4.259,14.763,4,14.504,4,14.184V9.766c0-0.319,0.259-0.578,0.578-0.578h3.541 l3.806-3.292c0.171-0.148,0.413-0.183,0.619-0.089C12.75,5.902,12.882,6.107,12.882,6.334z M17.894,17.994 C19.252,16.303,20,14.178,20,12.009c0-2.169-0.748-4.294-2.106-5.985c-0.2-0.249-0.564-0.289-0.813-0.089 c-0.249,0.2-0.289,0.564-0.089,0.813c2.449,3.048,2.449,7.472,0,10.52c-0.2,0.249-0.16,0.613,0.089,0.813 c0.107,0.086,0.235,0.128,0.362,0.128C17.612,18.21,17.78,18.136,17.894,17.994z M16.405,16.471c0.96-1.302,1.467-2.845,1.467-4.462 s-0.507-3.16-1.467-4.462c-0.19-0.257-0.552-0.312-0.809-0.122c-0.257,0.19-0.312,0.552-0.122,0.809 c1.664,2.258,1.664,5.292,0,7.551c-0.19,0.257-0.135,0.619,0.122,0.809c0.103,0.076,0.224,0.113,0.343,0.113 C16.116,16.706,16.291,16.625,16.405,16.471z M14.78,14.803c1.114-1.697,1.114-3.89,0-5.586c-0.175-0.267-0.534-0.341-0.801-0.166 c-0.267,0.175-0.341,0.534-0.166,0.801c0.861,1.311,0.861,3.005,0,4.317c-0.175,0.267-0.101,0.626,0.166,0.801 c0.098,0.064,0.208,0.095,0.317,0.095C14.484,15.064,14.669,14.972,14.78,14.803z',
    viewBox: '0 0 24 24'
  },
  starOutline: {
    path: 'M19.649,9.295l-4.84-0.42l-1.89-4.45c-0.34-0.81-1.5-0.81-1.84,0l-1.89,4.46l-4.83,0.41c-0.88,0.07-1.24,1.17-0.57,1.75 l3.67,3.18l-1.1,4.72c-0.2,0.86,0.73,1.54,1.49,1.08l4.15-2.5l4.15,2.51c0.76,0.46,1.69-0.22,1.49-1.08l-1.1-4.73l3.67-3.18 C20.879,10.465,20.529,9.365,19.649,9.295z M11.999,15.655l-3.76,2.27l1-4.28l-3.32-2.88l4.38-0.38l1.7-4.03l1.71,4.04l4.38,0.38 l-3.32,2.88l1,4.28L11.999,15.655z',
    viewBox: '0 0 24 24'
  },
  star: {
    path: 'M12,17.52l4.15,2.51c0.76,0.46,1.69-0.22,1.49-1.08l-1.1-4.72l3.67-3.18c0.67-0.58,0.31-1.68-0.57-1.75l-4.83-0.41 l-1.89-4.46c-0.34-0.81-1.5-0.81-1.84,0L9.19,8.88L4.36,9.29c-0.88,0.07-1.24,1.17-0.57,1.75l3.67,3.18l-1.1,4.72 c-0.2,0.86,0.73,1.54,1.49,1.08L12,17.52z',
    viewBox: '0 0 24 24'
  },
  tools: {
    path: 'M16.735,8.323l-2.609,2.61l-1.056-1.06l2.606-2.61l1.11-2.14L18.953,4L20,5.046l-1.122,2.169 L16.735,8.323L16.735,8.323z M4.439,17.443l4.92-4.921l2.12,2.118l-4.92,4.921c-0.281,0.282-0.662,0.44-1.06,0.439 c-0.827,0.001-1.499-0.669-1.5-1.496c0-0.398,0.158-0.78,0.44-1.062V17.443z M17.204,14.011c1.57,0.102,2.792,1.404,2.796,2.977 c0,0.461-0.112,0.893-0.3,1.285l-1.99-1.991c-0.102-0.101-0.225-0.178-0.36-0.225c-0.111-0.043-0.228-0.067-0.347-0.068 c-0.55,0-0.996,0.445-0.997,0.995c0,0.12,0.022,0.239,0.064,0.352c0.05,0.13,0.123,0.254,0.227,0.358l1.99,1.991 c-0.389,0.19-0.822,0.3-1.284,0.3c-1.573-0.002-2.875-1.225-2.975-2.795l-0.021-0.202c0-0.366,0.074-0.712,0.192-1.036L8.05,9.8 C7.726,9.918,7.38,9.993,7.014,9.993l-0.202-0.02C5.242,9.871,4.02,8.57,4.017,6.997c0-0.461,0.113-0.894,0.3-1.285l1.99,1.99 c0.102,0.1,0.225,0.178,0.36,0.226c0.111,0.043,0.228,0.066,0.347,0.068c0.265,0,0.519-0.105,0.706-0.292 c0.274-0.277,0.362-0.688,0.225-1.053C7.897,6.516,7.82,6.393,7.72,6.291L5.73,4.3C6.12,4.113,6.553,4,7.014,4 c1.573,0.003,2.875,1.225,2.977,2.795l0.02,0.202c0,0.366-0.075,0.713-0.195,1.036l6.15,6.152c0.324-0.12,0.67-0.194,1.036-0.194 C17.002,13.991,17.204,14.011,17.204,14.011z',
    viewBox: '0 0 24 24'
  },
  turtleHover: {
    path: 'M6.547,14.057L5.43,15.325L2.5,12l2.93-3.325l1.118,1.268l-1.022,1.16H9.15v1.794H5.525L6.547,14.057z M17.453,9.943 l1.118-1.268L21.5,12l-2.93,3.325l-1.118-1.268l1.022-1.16H14.85v-1.794h3.625L17.453,9.943z M11.05,7.725h1.9v8.55h-1.9 L11.05,7.725L11.05,7.725z',
    viewBox: '0 0 24 24'
  },
  turtleNormal: {
    path: 'M11.05,11.103v-6.23h1.9v6.23h3.625l-1.022-1.16l1.118-1.269L19.602,12l-2.931,3.326l-1.118-1.269l1.022-1.16H12.95v6.23 h-1.9v-6.23H7.424l1.022,1.16l-1.118,1.269L4.398,12l2.931-3.326l1.118,1.269l-1.022,1.16H11.05L11.05,11.103z',
    viewBox: '0 0 24 24'
  },
  videoOff: {
    path: 'M14.544,7.064l-9.76,9.725C4.3,16.511,4.001,15.995,4,15.437V8.564C4,7.7,4.695,7,5.574,7h8.524 C14.253,7,14.403,7.022,14.544,7.064z M15.672,9.798v5.64c0,0.862-0.695,1.562-1.574,1.562H8.445L15.672,9.798z M16.393,10.347 l2.979-2.17C19.719,7.925,20,8.079,20,8.505v6.31c0,0.433-0.307,0.634-0.713,0.438l-2.894-1.405 C16.393,13.848,16.393,10.347,16.393,10.347z M18.223,4.5l0.83,0.827L4.83,19.5L4,18.673L18.223,4.5z',
    viewBox: '0 0 24 24'
  },
  video: {
    path: 'M4,8.563C4,7.7,4.695,7,5.574,7h8.524c0.87,0,1.574,0.703,1.574,1.563v6.874c0,0.863-0.695,1.563-1.574,1.563H5.574 C4.708,17.002,4.004,16.303,4,15.437V8.564V8.563z M16.393,10.347l2.979-2.17C19.719,7.925,20,8.079,20,8.505v6.31 c0,0.433-0.307,0.634-0.713,0.438l-2.894-1.405C16.393,13.848,16.393,10.347,16.393,10.347z',
    viewBox: '0 0 24 24'
  },
  viewActiveSpeaker: {
    path: 'M13.919,18H5.198C4.537,18,4,17.436,4,16.741V7.259C4,6.564,4.537,6,5.198,6h8.721 c0.66,0,1.197,0.564,1.197,1.259v9.482C15.116,17.436,14.579,18,13.919,18z M5.198,7C5.09,7,5,7.119,5,7.259v9.482 C5,16.882,5.09,17,5.198,17h8.721c0.106,0,0.197-0.118,0.197-0.259V7.259c0-0.14-0.091-0.259-0.197-0.259H5.198z M18.803,9.655 h-2.094c-0.66,0-1.197-0.564-1.197-1.259V7.259C15.512,6.564,16.049,6,16.709,6h2.094C19.463,6,20,6.564,20,7.259v1.138 C20,9.091,19.463,9.655,18.803,9.655z M16.709,7c-0.106,0-0.197,0.119-0.197,0.259v1.138c0,0.14,0.091,0.259,0.197,0.259h2.094 C18.909,8.655,19,8.537,19,8.396V7.259C19,7.119,18.909,7,18.803,7H16.709z M18.803,13.827h-2.094c-0.66,0-1.197-0.564-1.197-1.258 v-1.138c0-0.694,0.537-1.259,1.197-1.259h2.094c0.66,0,1.197,0.564,1.197,1.259v1.138C20,13.263,19.463,13.827,18.803,13.827z M16.709,11.172c-0.106,0-0.197,0.119-0.197,0.259v1.138c0,0.14,0.091,0.258,0.197,0.258h2.094c0.106,0,0.197-0.118,0.197-0.258 v-1.138c0-0.14-0.091-0.259-0.197-0.259H16.709z M18.803,18h-2.094c-0.66,0-1.197-0.564-1.197-1.259v-1.138 c0-0.694,0.537-1.259,1.197-1.259h2.094c0.66,0,1.197,0.564,1.197,1.259v1.138C20,17.436,19.463,18,18.803,18z M16.709,15.345 c-0.106,0-0.197,0.118-0.197,0.259v1.138c0,0.141,0.091,0.259,0.197,0.259h2.094C18.909,17,19,16.882,19,16.741v-1.138 c0-0.141-0.091-0.259-0.197-0.259H16.709z',
    viewBox: '0 0 24 24'
  },
  viewEqual: {
    path: 'M18.73,11.552h-5c-0.699,0-1.269-0.564-1.269-1.259V7.259C12.462,6.564,13.031,6,13.73,6h5 C19.431,6,20,6.564,20,7.259v3.034C20,10.987,19.431,11.552,18.73,11.552z M13.73,7c-0.148,0-0.269,0.116-0.269,0.259v3.034 c0,0.143,0.12,0.259,0.269,0.259h5c0.148,0,0.27-0.116,0.27-0.259V7.259C19,7.116,18.879,7,18.73,7H13.73z M10.269,11.552h-5 c-0.7,0-1.269-0.564-1.269-1.259V7.259C4,6.564,4.569,6,5.269,6h5c0.7,0,1.27,0.564,1.27,1.259v3.034 C11.539,10.987,10.969,11.552,10.269,11.552z M5.269,7C5.121,7,5,7.116,5,7.259v3.034c0,0.143,0.121,0.259,0.269,0.259h5 c0.148,0,0.27-0.116,0.27-0.259V7.259c0-0.143-0.121-0.259-0.27-0.259H5.269z M10.269,18h-5C4.569,18,4,17.436,4,16.741v-3.034 c0-0.694,0.569-1.259,1.269-1.259h5c0.7,0,1.27,0.564,1.27,1.259v3.034C11.539,17.436,10.969,18,10.269,18z M5.269,13.448 C5.121,13.448,5,13.564,5,13.707v3.034C5,16.884,5.121,17,5.269,17h5c0.148,0,0.27-0.116,0.27-0.259v-3.034 c0-0.143-0.121-0.259-0.27-0.259H5.269z M18.73,18h-5c-0.699,0-1.269-0.564-1.269-1.259v-3.034c0-0.694,0.569-1.259,1.269-1.259h5 c0.7,0,1.27,0.564,1.27,1.259v3.034C20,17.436,19.431,18,18.73,18z M13.73,13.448c-0.148,0-0.269,0.116-0.269,0.259v3.034 c0,0.143,0.12,0.259,0.269,0.259h5c0.148,0,0.27-0.116,0.27-0.259v-3.034c0-0.143-0.121-0.259-0.27-0.259H13.73z',
    viewBox: '0 0 24 24'
  },
  viewLecturer: {
    path: 'M18.769,18H5.232C4.553,18,4,17.436,4,16.741V7.259C4,6.564,4.553,6,5.232,6h13.537 C19.447,6,20,6.564,20,7.259v9.482C20,17.436,19.447,18,18.769,18z M5.232,7C5.104,7,5,7.116,5,7.259v9.482 C5,16.884,5.104,17,5.232,17h13.537C18.896,17,19,16.884,19,16.741V7.259C19,7.116,18.896,7,18.769,7H5.232z',
    viewBox: '0 0 24 24'
  },
  wallpaper: {
    path: 'M5.6,5.6h5.6V4H5.6C4.72,4,4,4.72,4,5.6v5.6h1.6V5.6z M10.4,12.8l-3.2,4h9.6l-2.4-3.2l-1.624,2.168L10.4,12.8z M16,9.2 C16,8.536,15.464,8,14.8,8c-0.664,0-1.2,0.536-1.2,1.2c0,0.664,0.536,1.2,1.2,1.2C15.464,10.4,16,9.864,16,9.2z M18.4,4h-5.6v1.6 h5.6v5.6H20V5.6C20,4.72,19.28,4,18.4,4z M18.4,18.4h-5.6V20h5.6c0.88,0,1.6-0.72,1.6-1.6v-5.6h-1.6V18.4z M5.6,12.8H4v5.6 C4,19.28,4.72,20,5.6,20h5.6v-1.6H5.6V12.8z',
    viewBox: '0 0 24 24'
  },
  zoomIn: {
    path: 'M15.755,14.255h-0.79l-0.28-0.27c0.98-1.14,1.57-2.62,1.57-4.23c0-3.59-2.91-6.5-6.5-6.5s-6.5,2.91-6.5,6.5 s2.91,6.5,6.5,6.5c1.61,0,3.09-0.59,4.23-1.57l0.27,0.28v0.79l5,4.99l1.49-1.49L15.755,14.255z M9.755,14.255 c-2.49,0-4.5-2.01-4.5-4.5s2.01-4.5,4.5-4.5s4.5,2.01,4.5,4.5S12.245,14.255,9.755,14.255z M12.255,10.255h-2v2h-1v-2h-2v-1h2v-2h1 v2h2V10.255z',
    viewBox: '0 0 24 24'
  },
  zoomOut: {
    path: 'M15.755,14.255h-0.79l-0.28-0.27c0.98-1.14,1.57-2.62,1.57-4.23c0-3.59-2.91-6.5-6.5-6.5s-6.5,2.91-6.5,6.5 s2.91,6.5,6.5,6.5c1.61,0,3.09-0.59,4.23-1.57l0.27,0.28v0.79l5,4.99l1.49-1.49L15.755,14.255z M9.755,14.255 c-2.49,0-4.5-2.01-4.5-4.5s2.01-4.5,4.5-4.5s4.5,2.01,4.5,4.5S12.245,14.255,9.755,14.255z M7.255,9.255h5v1h-5V9.255z',
    viewBox: '0 0 24 24'
  }
};

var VideoButton = memo(forwardRef(function (props, ref) {
    var fabIcon = props.selected ? icons.videoOff : icons.video;
    return (React.createElement(BaseInCallButton, __assign({ ref: ref }, props),
        React.createElement(SvgIcon, { viewBox: fabIcon.viewBox },
            " ",
            React.createElement("path", { d: fabIcon.path }),
            " ")));
}));

function useSafariHack(videoEl) {
    useEffect(function () {
        var videoElementInterval = setInterval(function () {
            if (videoEl.current && videoEl.current.ended) {
                // eslint-disable-next-line
                videoEl.current.srcObject = videoEl.current.srcObject;
            }
        }, 250);
        return function cleanup() {
            if (videoElementInterval)
                clearInterval(videoElementInterval);
        };
    }, [videoEl]);
}

var useStyles$c = makeStyles$1(function () { return ({
    video: {
        bottom: 0,
        height: '100%',
        left: 0,
        position: 'absolute',
        right: 0,
        top: 0,
        width: '100%'
    }
}); });
// eslint-disable-next-line @typescript-eslint/no-empty-function
var noop = function () { };
var VideoStream = function (_a) {
    var className = _a.className, dataTestId = _a.dataTestId, id = _a.id, getStreamAspect = _a.getStreamAspect, mediaStream = _a.mediaStream, _b = _a.muted, muted = _b === void 0 ? false : _b, _c = _a.onAspectChange, onAspectChange = _c === void 0 ? noop : _c, _d = _a.onPlaybackFailure, onPlaybackFailure = _d === void 0 ? noop : _d, _e = _a.onPlaybackSuccess, onPlaybackSuccess = _e === void 0 ? noop : _e, _f = _a.startTime, startTime = _f === void 0 ? 0 : _f, style = _a.style;
    var classes = useStyles$c();
    var videoEl = useRef(null);
    var videoElement = videoEl.current;
    var otherAttr = { id: id, style: style };
    useSafariHack(videoEl);
    var playVideo = useCallback(function (videoElement) { return __awaiter(void 0, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, videoElement.play()];
                case 1:
                    _a.sent(); // wait for the promise
                    onPlaybackSuccess(startTime);
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    onPlaybackFailure(e_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, [startTime, onPlaybackFailure, onPlaybackSuccess]);
    var measureVideoAspect = useCallback(function () {
        getStreamAspect && onAspectChange(getStreamAspect(videoElement));
    }, [onAspectChange, videoElement, getStreamAspect]);
    useEffect(function () {
        if (videoElement) {
            videoElement.addEventListener('playing', measureVideoAspect);
            videoElement.addEventListener('resize', measureVideoAspect);
        }
        return function () {
            if (videoElement) {
                videoElement.removeEventListener('playing', measureVideoAspect);
                videoElement.removeEventListener('resize', measureVideoAspect);
            }
        };
    }, [measureVideoAspect, videoElement]);
    useEffect(function () {
        if (videoEl.current && mediaStream) {
            if (videoEl.current.srcObject !== mediaStream) {
                videoEl.current.srcObject = mediaStream;
            }
            if (videoEl.current.paused) {
                playVideo(videoEl.current);
            }
        }
    }, [id, mediaStream, playVideo, videoEl]);
    if (!mediaStream) {
        return null;
    }
    return (React.createElement("video", __assign({ autoPlay: true, className: clsx(classes.video, className, 'lsVideoElt'), "data-testid": dataTestId, muted: muted, playsInline: true, ref: videoEl }, otherAttr)));
};

export { AudioButton, Badge, BaseInCallButton, Button, ButtonBar, classKeys as ButtonBarClassKeys, CancelButton, ChatButton, CloseButton, Dropdown as DropDown, EndCallButton, LifesizeInput as Input, LanguageSwitcher, theme as MUIComponentsTheme, LifesizeMenuItem as MenuItem, Modal, MoreButton, MultiSwitch, ParticipantsButton, PipButton, PresentButton, RaiseHandButton, RecordingButton, RetryButton, SettingsButton, Snackbar, SwipeableDrawer, Switch, VbbButton, VideoButton, VideoStream, colors };
